window.reviews = [



  {
        "name": "Anna Keller",
        "rating": 5,
        "gender": "female",
        "review": "Alles gut.",
        "date": "2022-11-15"
    },
    {
        "name": "Elisa van den Berg",
        "rating": 4,
        "gender": "female",
        "review": "Qualität gut, Lieferung hat etwas gedauert, aber Kundensupport war freundlich und hilfsbereit.",
        "date": "2023-05-07"
    },
    {
        "name": "Paulina Wolska",
        "rating": 5,
        "gender": "female",
        "review": "Die Verpackung war wunderschön – man merkt, dass hier viel Herzblut hineingesteckt wird. Es ist einfach toll, dass Nachhaltigkeit so großgeschrieben wird. Ein Kleidungsstück hat mir nicht gepasst, aber die Rücksendung war einfach und kostenfrei. Top!",
        "date": "2024-02-12"
    },
    {
        "name": "Marie Lefevre",
        "rating": 5,
        "gender": "female",
        "review": "Ich bin total begeistert! Die Qualität der Produkte übertrifft meine Erwartungen, und der Umtauschprozess war unglaublich einfach. Ich hatte das Gefühl, dass sich wirklich jemand um mein Anliegen kümmert. Außerdem kam meine Bestellung innerhalb von 2 Tagen – das war eine positive Überraschung!",
        "date": "2021-08-23"
    },
    {
        "name": "Noemi Janssen",
        "rating": 4,
        "gender": "female",
        "review": "Die Produkte sind schön und preiswert. Leider hat die Lieferung 10 Tage gedauert, obwohl ich auf eine schnellere Lieferung gehofft hatte. Trotzdem war die Kommunikation mit dem Kundenservice super. Man wird hier einfach gut betreut.",
        "date": "2022-03-17"
    },
    {
        "name": "Sofia Garcia",
        "rating": 5,
        "gender": "female",
        "review": "Achtung: Unbedingt nur hier bestellen und aufpassen, dass man nicht bei Fake-Shops landet! Ich habe einmal bei einem Fake-Shop bestellt und musste Lehrgeld zahlen. Hier ist die Qualität immer top, und selbst wenn etwas mal nicht passt, ist der Umtausch total unkompliziert. Das schätze ich sehr.",
        "date": "2023-09-10"
    },
    {
        "name": "Lucia Novak",
        "rating": 4,
        "gender": "female",
        "review": "Ich habe länger auf meine Bestellung gewartet (12 Tage), aber der Kundenservice hat mich darüber regelmäßig informiert und mir sogar einen kleinen Rabatt als Entschuldigung gegeben. Die Produkte sind wunderschön und hochwertig. So einen Service wünsche ich mir überall!",
        "date": "2024-06-22"
    },
    {
        "name": "Helena Olofsson",
        "rating": 5,
        "gender": "female",
        "review": "<strong>Ich bin absolut zufrieden!</strong> Vom Bestellprozess bis zur Lieferung war alles perfekt. Die handgefertigte Verpackung war so liebevoll gestaltet, dass ich das Auspacken fast schon gefeiert habe. Die Produkte selbst sind qualitativ hochwertig und genau wie abgebildet. Es ist beruhigend zu wissen, dass Nachhaltigkeit hier wirklich zählt. Die Lieferung war super schnell (nur 2 Tage!) – das war ein Traum.",
        "date": "2023-12-05"
    },
    {
        "name": "Maja Fontaine",
        "rating": 4,
        "gender": "female",
        "review": "<strong>Pro:</strong> Tolle Auswahl, preiswert, super Qualität. <br><strong>Contra:</strong> Die Lieferzeit war mit 14 Tagen länger als erwartet. <br><strong>Fazit:</strong> Ich werde hier auf jeden Fall wieder bestellen, da der Service hervorragend war und die Produkte wirklich überzeugen. Danke für den großartigen Support!",
        "date": "2024-03-29"
    },
    {
        "name": "Yara de Vries",
        "rating": 5,
        "gender": "female",
        "review": "<strong>Ein perfektes Einkaufserlebnis.</strong> Prime-Moda hat wirklich alle Erwartungen übertroffen. Ich war zunächst skeptisch, ob die Produkte so aussehen würden wie auf den Bildern – aber ich wurde positiv überrascht. Die Verpackung war so schön, dass ich sie fast behalten wollte, und die Qualität der Kleidung ist hervorragend. Besonders erwähnen möchte ich den Kundenservice: Nach einer kleinen Frage zu meiner Bestellung wurde mir sofort freundlich und kompetent geholfen. Die nachhaltige Produktion und die kostenfreie Rücksendung heben diesen Shop deutlich von anderen ab. Hier merkt man, dass der Kunde wirklich im Mittelpunkt steht. Ein großes Dankeschön an das gesamte Team!",
        "date": "2024-08-19"
    },
    {
        "name": "Iris Becker",
        "rating": 5,
        "gender": "female",
        "review": "schnelle lieferung, top ware!",
        "date": "2023-10-15"
    },
    {
        "name": "Solange Martinez",
        "rating": 4,
        "gender": "female",
        "review": "Bestellung kam nach 5 Tagen. Schöne Verpackung und gute Qualität. Empfehlenswert.",
        "date": "2024-01-20"
    },
    {
        "name": "Dagmar Wojciechowski",
        "rating": 5,
        "gender": "female",
        "review": "Der Kundenservice ist einfach super! Wurde immer über den Status informiert und die Verpackung war wunderschön. Die Qualität stimmt auch.",
        "date": "2023-06-18"
    },
    {
        "name": "Anouk van der Heijden",
        "rating": 5,
        "gender": "female",
        "review": "Toller Shop mit ausgezeichnetem Service. Die kostenlose Rücksendung ist echt klasse, sowas gibt es kaum noch. Lieferung dauerte 8 Tage, aber die Qualität ist top!",
        "date": "2023-12-03"
    },
    {
        "name": "Louise Delacroix",
        "rating": 4,
        "gender": "female",
        "review": "Ein wirklich vorbildlicher Shop! Die nachhaltige Produktion spiegelt sich in der Qualität wider. Kundenservice ist außergewöhnlich gut und die handgemachte Verpackung macht jede Bestellung zu etwas Besonderem. Lieferzeit betrug 10 Tage.",
        "date": "2024-02-28"
    },
    {
        "name": "Marika Järvinen",
        "rating": 5,
        "gender": "female",
        "review": "<strong>Hervorragender Online-Shop!</strong><br><br>Pros:<br>- Erstklassige nachhaltige Qualität<br>- Kostenlose Retouren<br>- Toller Service<br>- Liebevolle Verpackung<br><br>Kontras:<br>- Lieferzeit variiert<br><br>Fazit: Absolute Kaufempfehlung!",
        "date": "2023-09-05"
    },
    {
        "name": "Iris Kaczmarek",
        "rating": 5,
        "gender": "female",
        "review": "<strong>Endlich ein Shop mit Herz!</strong><br><br>Die Qualität ist durchweg hochwertig und der Kundenservice beispielhaft. Als meine Lieferung sich verzögerte, erhielt ich nicht nur regelmäßige Updates, sondern auch einen großzügigen Rabatt! Die handgemachte Verpackung ist immer wieder ein Highlight. Besonders toll finde ich das kostenlose Rücksendesystem - andere Shops verlangen dafür mittlerweile Gebühren.",
        "date": "2023-11-12"
    },
    {
        "name": "Eline Vandersteen",
        "rating": 5,
        "gender": "female",
        "review": "<strong>Ein Vorbild in Sachen Online-Shopping!</strong><br><br>Die nachhaltige Produktion und faire Preisgestaltung überzeugen vollständig. Der Kundenservice ist einmalig - proaktive Kommunikation und kulante Lösungen bei Verzögerungen. Die Lieferzeiten variieren zwar, aber dafür ist die Qualität top!<br><br>WICHTIG: Vorsicht vor Fake-Shops in sozialen Medien mit kopierten Bildern. Die vermeintliche Ersparnis von 20-30€ führt oft zu minderwertiger Ware.<br><br>Die kostenlose Rücksendeoption ist heute einzigartig und die handgefertigte Verpackung macht jede Bestellung besonders.",
        "date": "2024-01-15"
    },
    {
        "name": "Catalina Fernández",
        "rating": 5,
        "gender": "female",
        "review": "<strong>Herausragender Service und Qualität!</strong><br><br>Details zur Bewertung:<br>- Erstklassige, nachhaltige Produktion<br>- Vorbildlicher Kundenservice mit proaktiver Kommunikation<br>- Einzigartiges kostenloses Rücksendesystem<br>- Wunderschöne handgefertigte Verpackung<br><br>Bei Lieferverzögerungen wird man großzügig entschädigt - in meinem Fall komplette Erstattung plus Behalten der Artikel! Die Lieferzeiten von 1-15 Tagen sind durch die nachhaltige Produktion begründet.<br><br>Warnung: Finger weg von Fake-Shops mit gleichen Bildern! Die Original-Qualität ist den Aufpreis absolut wert.",
        "date": "2023-08-22"
    },
    {
        "name": "Aurelie Beaumont",
        "rating": 5,
        "gender": "female",
        "review": "<strong>Die Zukunft des Online-Shoppings!</strong><br><br>1. Qualität & Nachhaltigkeit:<br>- Premium Materialien und Verarbeitung<br>- Nachhaltige Produktion<br>- Faire Preise für Top-Qualität<br><br>2. Service Excellence:<br>- Außergewöhnlicher Kundenservice<br>- Transparente Kommunikation<br>- Kulante Lösungen (erhielt bei Verzögerung volle Erstattung + durfte Artikel behalten)<br><br>3. Besondere Merkmale:<br>- Liebevolle, handgefertigte Verpackung<br>- Flexibles Liefersystem (1-15 Tage)<br>- Kostenloses Rücksendesystem (einzigartig im Vergleich zu anderen Shops)<br><br>4. Wichtiger Hinweis:<br>- Vorsicht vor Fake-Shops in sozialen Medien<br>- Identische Bilder, aber minderwertige Qualität<br>- Original-Qualität rechtfertigt den Preisunterschied<br><br>Fazit: Dieser Shop setzt neue Maßstäbe in Sachen Nachhaltigkeit, Kundenservice und Qualität. Absolute Empfehlung!",
        "date": "2024-02-15"
    },
    {
        "name": "Anna Keller",
        "rating": 5,
        "gender": "female",
        "review": "Sehr zufrieden, alles top.",
        "date": "2022-07-18"
    },
    {
        "name": "Sofia Montoya",
        "rating": 4,
        "gender": "female",
        "review": "Lieferung kam nach einer Woche an, Qualität gut, Kundenservice freundlich.",
        "date": "2023-02-12"
    },
    {
        "name": "Emilia Novak",
        "rating": 5,
        "gender": "female",
        "review": "Die Verpackung war so liebevoll, das macht das Auspacken zu einem Erlebnis! Rücksendung kostenlos, was ich super finde.",
        "date": "2021-09-03"
    },
    {
        "name": "Claire Dupont",
        "rating": 5,
        "gender": "female",
        "review": "Ich bin begeistert von der Qualität und der Nachhaltigkeit der Produkte. Der Kundenservice ist außergewöhnlich – immer freundlich und hilfsbereit. Lieferung war nach drei Tagen da. Einfach toll!",
        "date": "2024-01-17"
    },
    {
        "name": "Kaisa Virtanen",
        "rating": 4,
        "gender": "female",
        "review": "Die Bestellung dauerte länger als erwartet (12 Tage), aber ich wurde über alles auf dem Laufenden gehalten. Die Produkte sind sehr schön und hochwertig.",
        "date": "2023-08-09"
    },
    {
        "name": "Lucia de Vries",
        "rating": 5,
        "gender": "female",
        "review": "Achtung vor Fake-Shops! Hier stimmt die Qualität immer, und bei Problemen kümmert sich der Support. Ich bestelle nur noch hier.",
        "date": "2023-05-21"
    },
    {
        "name": "Helene Jablonski",
        "rating": 4,
        "gender": "female",
        "review": "Pro: Nachhaltige Produkte, einfache Rücksendung. Contra: Lieferung dauerte diesmal 10 Tage. Fazit: Trotzdem sehr zufrieden und werde wieder bestellen!",
        "date": "2024-02-10"
    },
    {
        "name": "Fiona van den Berg",
        "rating": 5,
        "gender": "female",
        "review": "<strong>Unglaublich zufrieden!</strong> Die handgemachte Verpackung ist einfach wunderschön, die Produkte hochwertig und der Service ein Traum. Alles verlief reibungslos, ich habe meine Bestellung nach 2 Tagen erhalten. Weiter so!",
        "date": "2022-03-27"
    },
    {
        "name": "Marie Dupuis",
        "rating": 4,
        "gender": "female",
        "review": "<strong>Pros:</strong> Qualität ist hervorragend, Support sehr hilfsbereit. <br><strong>Cons:</strong> Lieferung dauerte fast zwei Wochen. <br><strong>Fazit:</strong> Ich werde definitiv wieder hier bestellen, da die Vorteile deutlich überwiegen.",
        "date": "2024-06-05"
    },
    {
        "name": "Elise Janssen",
        "rating": 5,
        "gender": "female",
        "review": "<strong>Ein durchweg positives Einkaufserlebnis!</strong> Vom Bestellprozess über die Lieferung bis hin zur Qualität der Produkte – alles war perfekt. Besonders beeindruckt hat mich der persönliche Touch: Die Verpackung war handgefertigt und mit so viel Liebe gestaltet. Die Kleidung ist hochwertig, nachhaltig und wirklich schön verarbeitet. Der Kundenservice reagiert schnell und löst jedes Problem sofort. Man merkt, dass der Kunde hier im Mittelpunkt steht. Absolut empfehlenswert!",
        "date": "2023-11-14"
    },
    {
        "name": "Marie Schneider",
        "rating": 5,
        "gender": "female",
        "review": "Super Qualität! Sehr schnelle Lieferung. Gerne wieder!",
        "date": "2021-06-15"
    },
    {
        "name": "Isabella Martinez",
        "rating": 5,
        "gender": "female",
        "review": "Tolles Design und die Verpackung ist so liebevoll gestaltet. Schneller Versand. Danke!",
        "date": "2023-09-03"
    },
    {
        "name": "Sophie Kowalski",
        "rating": 4,
        "gender": "female",
        "review": "Die Bestellung kam nach 10 Tagen an. Die Qualität ist super und der Kundenservice ist sehr freundlich. Kleiner Abzug wegen der Wartezeit, aber das wurde mit einem Rabattgutschein wieder gut gemacht.",
        "date": "2021-12-22"
    },
    {
        "name": "Amélie van der Berg",
        "rating": 5,
        "gender": "female",
        "review": "Endlich ein Shop, der kostenlose Rücksendungen anbietet! Das Produkt war leider etwas zu groß, aber der Umtausch war absolut problemlos. Der neue Artikel kam innerhalb von 3 Tagen. Super Service!",
        "date": "2022-03-14"
    },
    {
        "name": "Helena Virtanen",
        "rating": 5,
        "gender": "female",
        "review": "<strong>Absolut empfehlenswert!</strong><br><br>Positiv:<br>- Schnelle Lieferung (4 Tage)<br>- Hochwertige Qualität<br>- Toller Kundenservice<br>- Faire Preise<br><br>Der Support ist wirklich ausgezeichnet und hält einen immer auf dem Laufenden. Werde definitiv wieder bestellen!",
        "date": "2022-08-07"
    },
    {
        "name": "Lena Dubois",
        "rating": 5,
        "gender": "female",
        "review": "<strong>Fantastischer Shop - aber Vorsicht vor Fake-Shops!</strong><br><br>Habe schon mehrfach hier bestellt und bin jedes Mal begeistert. Die Qualität ist hervorragend und die handgefertigte Verpackung macht jede Bestellung zu etwas Besonderem. Wichtig: Bestellt nur auf der originalen Webseite, es gibt viele Fake-Shops die die gleichen Bilder verwenden!",
        "date": "2023-01-19"
    },
    {
        "name": "Carmen Velasco",
        "rating": 4,
        "gender": "female",
        "review": "<strong>Toller Shop mit nachhaltiger Mode</strong><br><br>Pros:<br>- Nachhaltige Produktion<br>- Exzellente Qualität<br>- Kostenlose Retouren<br>- Super Kundenservice<br><br>Cons:<br>- Lieferzeiten variieren stark (5-15 Tage)<br><br>Fazit: Die etwas längeren Lieferzeiten nehme ich gerne in Kauf, da die Qualität und Nachhaltigkeit stimmen. Der Kundenservice ist vorbildlich und reagiert immer schnell und kompetent.",
        "date": "2023-05-30"
    },
    {
        "name": "Victoria Novotna",
        "rating": 5,
        "gender": "female",
        "review": "<strong>Ein Vorbild in Sachen Kundenservice und Qualität!</strong><br><br>Nach mehreren Fehlkäufen bei diversen Fake-Shops bin ich überglücklich, endlich einen seriösen Anbieter gefunden zu haben. Die Qualität ist jeden Euro wert und die Lieferzeiten sind transparent kommuniziert. Besonders beeindruckt hat mich der Kundenservice: Als sich meine Bestellung einmal verzögerte, wurde ich nicht nur proaktiv informiert, sondern erhielt sogar einen großzügigen Rabatt als Entschädigung.<br><br>Die handgemachte Verpackung zeigt die Liebe zum Detail. Man merkt einfach, dass hier nicht auf Masse produziert wird, sondern jede Bestellung individuell mit Sorgfalt bearbeitet wird.",
        "date": "2023-11-12"
    },
    {
        "name": "Elise Vandenberghe",
        "rating": 5,
        "gender": "female",
        "review": "<strong>Der beste Online-Shop für nachhaltige Mode - Eine ausführliche Bewertung</strong><br><br>Nach unzähligen Bestellungen möchte ich endlich meine Erfahrungen teilen. Die Lieferzeiten variieren zwar von 1-15 Tagen, aber das liegt an der nachhaltigen Produktion und wird transparent kommuniziert. Der Kundenservice ist beispiellos - schnelle Antworten, proaktive Updates und kulante Lösungen bei Problemen.<br><br>Die kostenlose Rücksendeoption ist heutzutage keine Selbstverständlichkeit mehr (siehe große Modeketten). Hier zeigt sich die kundenorientierte Philosophie des Shops. Die Qualität überzeugt durchgehend, und sollte mal etwas nicht gefallen, ist der Umtausch absolut problemlos.<br><br>Besonders hervorzuheben ist die handgefertigte Verpackung - ein Detail, das zeigt, dass hier jede Bestellung mit Liebe behandelt wird.<br><br>Wichtiger Hinweis: Lasst euch nicht von Fake-Shops täuschen, die die gleichen Bilder verwenden. Der Preisunterschied lohnt sich definitiv für die garantierte Qualität.",
        "date": "2024-02-28"
    },
    {
        "name": "Aurelia Kovácz",
        "rating": 5,
        "gender": "female",
        "review": "<strong>Eine Liebeserklärung an nachhaltigen Mode-Konsum</strong><br><br>Als langjährige Kundin möchte ich eine umfassende Bewertung abgeben, die hoffentlich anderen Kaufinteressenten die Entscheidung erleichtert.<br><br>Zunächst zur Qualität: Die Produkte überzeugen durchweg mit hochwertiger Verarbeitung und nachhaltigen Materialien. Ja, sie sind eventuell etwas teurer als bei Fast-Fashion-Ketten, aber das Preis-Leistungs-Verhältnis ist absolut gerechtfertigt.<br><br>Der Versandprozess verdient besondere Erwähnung: Die Lieferzeiten variieren naturgemäß aufgrund der nachhaltigen Produktion, werden aber transparent kommuniziert. Jede Bestellung wird mit einer handgefertigten Verpackung versehen - ein Detail, das den persönlichen Touch unterstreicht.<br><br>Der Kundenservice setzt neue Maßstäbe: Bei einer verspäteten Lieferung wurde ich nicht nur proaktiv informiert, sondern erhielt auch eine großzügige Entschädigung. Das kostenlose Rücksendesystem ist in Zeiten, wo selbst große Modeketten Gebühren erheben, ein echter Mehrwert.<br><br>WICHTIGER HINWEIS: Es existieren leider viele Fake-Shops, die die gleichen Produktbilder verwenden und mit Dumping-Preisen locken. Die Enttäuschung ist dann meist groß, wenn minderwertige Ware oder gar nichts geliefert wird. Bestellt ausschließlich im Original-Shop!<br><br>Fazit: Wer Wert auf Nachhaltigkeit, Qualität und exzellenten Service legt, ist hier goldrichtig. Die gelegentlich längeren Lieferzeiten sind ein kleiner Preis für garantierte Qualität und nachhaltigen Konsum.",
        "date": "2024-08-15"
    },
    {
        "name": "Lena Bäcker",
        "rating": 5,
        "gender": "female",
        "date": "2021-06-15",
        "review": "Super Qualität, schnelle Lieferung."
    },
    {
        "name": "Marta Nowicka",
        "rating": 4,
        "gender": "female",
        "date": "2022-08-12",
        "review": "Alles ok, aber die Lieferung hat etwas gedauert. Zum Glück hat der Support schnell geantwortet!"
    },
    {
        "name": "Camille Moreau",
        "rating": 5,
        "gender": "female",
        "date": "2023-01-27",
        "review": "Die Verpackung war wirklich liebevoll gestaltet, und ich hatte das Gefühl, dass jede Bestellung mit Herz behandelt wird. Der Umtausch hat problemlos geklappt, als ich die falsche Größe hatte – kostenloser Rückversand ist einfach spitze!"
    },
    {
        "name": "Sofie van der Meer",
        "rating": 5,
        "gender": "female",
        "date": "2023-04-10",
        "review": "Ehrlich gesagt, die Qualität hat mich positiv überrascht. Nachhaltige Mode zu fairen Preisen – ich komme definitiv wieder!"
    },
    {
        "name": "Elisabeth Koenig",
        "rating": 4,
        "gender": "female",
        "date": "2023-11-19",
        "review": "Achtung vor Fake-Shops! Hier ist alles seriös, und ich bin froh, dass ich die richtige Wahl getroffen habe. Lieferung war flott, und die Qualität überzeugt."
    },
    {
        "name": "Ana Delgado",
        "rating": 5,
        "gender": "female",
        "date": "2022-03-04",
        "review": "Ich musste zwei Wochen auf meine Bestellung warten, aber es hat sich gelohnt. Die Kleidung sieht genauso aus wie auf den Bildern, und der Kundenservice war sehr hilfsbereit. Besonders toll fand ich, dass ich bei einer Verzögerung einen Rabatt bekommen habe – das ist echter Kundenservice!"
    },
    {
        "name": "Frida Nyman",
        "rating": 4,
        "gender": "female",
        "date": "2023-05-08",
        "review": "Schöne Produkte, aber ich hatte eine etwas längere Wartezeit. Trotzdem kaufe ich wieder ein, da die Verpackung und der Rücksendeservice einzigartig sind."
    },
    {
        "name": "Zofia Krawczyk",
        "rating": 5,
        "gender": "female",
        "date": "2023-12-15",
        "review": "<strong>Ich bin einfach begeistert!</strong><br>Die Verpackung – ein Traum, der Kundenservice – unschlagbar, und die Produkte – wunderschön und hochwertig. Ich habe schon oft hier bestellt und wurde nie enttäuscht. Besonders die nachhaltige Philosophie gefällt mir. Andere Shops können sich hier echt eine Scheibe abschneiden!"
    },
    {
        "name": "Helena Leclerc",
        "rating": 5,
        "gender": "female",
        "date": "2024-07-28",
        "review": "Ich war skeptisch, aber ich bin jetzt treue Kundin. Die Kleidung sitzt perfekt, der Umtauschservice ist großartig, und die Preise sind für die Qualität absolut gerechtfertigt. Mein Favorit unter den Onlineshops!"
    },
    {
        "name": "Katrijn Vissers",
        "rating": 5,
        "gender": "female",
        "date": "2023-02-19",
        "review": "Einzigartig! Ich habe noch nie so einen tollen Online-Shop erlebt. Qualität, Nachhaltigkeit, Service – alles top. Besonders gut finde ich, dass man sogar bei kleinen Problemen ernst genommen wird. Weiter so!"
    },
    {
        "name": "Mila Kowalczyk",
        "rating": 5,
        "gender": "female",
        "date": "2021-08-12",
        "eloquence_level": 1,
        "review": "Super schnelle Lieferung! Qualität top!"
    },
    {
        "name": "Lucia García",
        "rating": 5,
        "gender": "female",
        "date": "2021-11-23",
        "eloquence_level": 2,
        "review": "Tolle Verpackung und super Service. Bin sehr zufrieden mit meiner Bestellung."
    },
    {
        "name": "Emma Dubois",
        "rating": 4,
        "gender": "female",
        "date": "2022-02-14",
        "eloquence_level": 3,
        "review": "Sehr schöne Ware und liebevolle Verpackung. Hat etwas länger gedauert als erwartet (12 Tage), aber der Support war sehr freundlich und hat mich ständig informiert."
    },
    {
        "name": "Lena Van Dijk",
        "rating": 5,
        "gender": "female",
        "date": "2022-05-30",
        "eloquence_level": 4,
        "review": "Kostenlose Retoure ist wirklich klasse! Musste eine andere Größe bestellen und der Umtausch lief absolut reibungslos. Der neue Artikel war nach 3 Tagen da. Top Service!"
    },
    {
        "name": "Sofia Nieminen",
        "rating": 5,
        "gender": "female",
        "date": "2022-09-18",
        "eloquence_level": 5,
        "review": "<strong>Sehr empfehlenswert!</strong><br><br>Positiv:<br>- Lieferung in 5 Tagen<br>- Erstklassige Qualität<br>- Hervorragender Support<br>- Faire Preise<br><br>Alles perfekt gelaufen, gerne wieder!"
    },
    {
        "name": "Charlotte Beaumont",
        "rating": 5,
        "gender": "female",
        "date": "2023-03-03",
        "eloquence_level": 6,
        "review": "<strong>Endlich ein seriöser Shop!</strong><br><br>Nach vielen schlechten Erfahrungen mit Fake-Shops bin ich überglücklich, einen vertrauenswürdigen Anbieter gefunden zu haben. Die Qualität ist super und die handgemachte Verpackung ist einfach wunderschön. Achtung vor den vielen Fake-Shops mit den gleichen Bildern!"
    },
    {
        "name": "Ana Rodríguez",
        "rating": 4,
        "gender": "female",
        "date": "2023-07-22",
        "eloquence_level": 7,
        "review": "<strong>Nachhaltige Mode mit Herz</strong><br><br>Vorteile:<br>- Nachhaltige Produktion<br>- Top Qualität<br>- Gratis Retouren<br>- Exzellenter Service<br><br>Nachteile:<br>- Lieferzeit schwankend<br><br>Fazit: Die manchmal längere Lieferzeit ist es definitiv wert. Kundenservice ist vorbildlich und die Qualität stimmt einfach."
    },
    {
        "name": "Natalia Wojcik",
        "rating": 5,
        "gender": "female",
        "date": "2023-12-15",
        "eloquence_level": 8,
        "review": "<strong>Kundenservice der Extraklasse!</strong><br><br>Die Qualität der Artikel ist jeden Cent wert. Als sich meine Bestellung mal verzögerte, wurde ich nicht nur sofort informiert, sondern bekam auch noch einen großzügigen Gutschein. Die handgemachte Verpackung zeigt die große Sorgfalt, die hier in jede einzelne Bestellung gesteckt wird.<br><br>Die Lieferzeiten sind transparent kommuniziert und der Support ist immer erreichbar. Ein rundum gelungenes Einkaufserlebnis!"
    },
    {
        "name": "Marie-Claire Janssens",
        "rating": 5,
        "gender": "female",
        "date": "2024-04-28",
        "eloquence_level": 9,
        "review": "<strong>Der beste Shop für nachhaltige Mode - Eine detaillierte Bewertung</strong><br><br>Die Lieferzeiten variieren zwischen 1-15 Tagen, was der nachhaltigen Produktion geschuldet ist. Der Kundenservice ist einmalig - schnelle Reaktionen, proaktive Updates und kulante Problemlösungen.<br><br>Die kostenlose Rücksendung ist heute keine Selbstverständlichkeit mehr, umso mehr weiß man diesen Service zu schätzen. Die Qualität ist durchgehend überzeugend und die handgefertigte Verpackung macht jede Bestellung zu etwas Besonderem.<br><br>Wichtig: Vorsicht vor den vielen Fake-Shops mit kopierten Bildern. Der kleine Aufpreis hier lohnt sich definitiv für die garantierte Qualität und den ausgezeichneten Service."
    },
    {
        "name": "Elena Popov",
        "rating": 5,
        "gender": "female",
        "date": "2024-08-19",
        "eloquence_level": 10,
        "review": "<strong>Ein Vorbild für nachhaltigen Online-Handel</strong><br><br>Nach jahrelanger Erfahrung mit diesem Shop möchte ich eine ausführliche Bewertung teilen.<br><br>Die Qualität: Durchweg hochwertig und nachhaltig produziert. Der höhere Preis im Vergleich zu Fast-Fashion ist absolut gerechtfertigt.<br><br>Versand & Verpackung: Die Lieferzeiten schwanken naturgemäß wegen der nachhaltigen Produktion, werden aber transparent kommuniziert. Die handgefertigte Verpackung macht jede Bestellung zu einem besonderen Erlebnis.<br><br>Kundenservice: Hier werden neue Standards gesetzt. Bei Verzögerungen wird man proaktiv informiert und großzügig entschädigt. Das kostenlose Rücksendesystem ist in Zeiten von Retourengebühren bei großen Modeketten ein echter Pluspunkt.<br><br>WARNUNG: Es existieren zahlreiche Fake-Shops mit identischen Produktbildern und Dumping-Preisen. Die gelieferte Ware ist dann meist minderwertig oder kommt gar nicht an. Bestellt nur im Original-Shop!<br><br>Fazit: Für alle, die Wert auf Nachhaltigkeit, Qualität und erstklassigen Service legen, führt kein Weg an diesem Shop vorbei. Die variierenden Lieferzeiten sind ein kleiner Preis für garantierte Qualität und nachhaltigen Konsum."
    },

  {
        "name": "Alicia Schäfer",
        "rating": 5,
        "gender": "female",
        "date": "2022-09-05",
        "review": "Lieferung war blitzschnell, super zufrieden!"
    },
    {
        "name": "Emilia Fernández",
        "rating": 4,
        "gender": "female",
        "date": "2023-06-22",
        "review": "Die Ware war schön, aber die Lieferung hat etwas länger gedauert. Dennoch, ich bestelle wieder!"
    },
    {
        "name": "Maëlys Dupont",
        "rating": 5,
        "gender": "female",
        "date": "2021-12-12",
        "review": "Wirklich toller Shop, der Kundenservice ist immer freundlich und hilfsbereit. Als ich wegen einer Verzögerung nachfragte, habe ich sogar einen Rabatt bekommen. Das nenne ich Kundenorientierung!"
    },
    {
        "name": "Jana Novak",
        "rating": 5,
        "gender": "female",
        "date": "2023-10-30",
        "review": "Einfach nur begeistert! Verpackung, Qualität und der Service sind hervorragend. Besonders gefällt mir, dass alles nachhaltig produziert wird."
    },
    {
        "name": "Charlotte Meijer",
        "rating": 4,
        "gender": "female",
        "date": "2023-01-18",
        "review": "Der kostenlose Rückversand hat mir echt geholfen, weil ich eine falsche Größe bestellt hatte. Lieferung könnte aber schneller sein."
    },
    {
        "name": "Aneta Kowalska",
        "rating": 5,
        "gender": "female",
        "date": "2024-03-15",
        "review": "<strong>Wow, ich bin begeistert!</strong><br>Die Qualität der Produkte übertrifft meine Erwartungen, und der Kundenservice war unglaublich zuvorkommend. Ich hatte ein Problem mit der Größe, und der Umtausch lief reibungslos. So einen Service habe ich selten erlebt!"
    },
    {
        "name": "Valérie Rousseau",
        "rating": 5,
        "gender": "female",
        "date": "2023-04-01",
        "review": "Ich habe schon mehrmals hier bestellt und wurde nie enttäuscht. Qualität, Nachhaltigkeit und der schnelle Support machen diesen Shop einzigartig!"
    },
    {
        "name": "Noemi van Dijk",
        "rating": 5,
        "gender": "female",
        "date": "2023-07-07",
        "review": "Einzigartige Produkte und ein wirklich liebevoller Service. Die handgemachte Verpackung ist ein kleines Highlight bei jeder Bestellung!"
    },
    {
        "name": "Sofia Horváth",
        "rating": 4,
        "gender": "female",
        "date": "2022-11-09",
        "review": "Leider hat meine Lieferung etwas gedauert, aber die Qualität der Produkte hat mich entschädigt. Auch der Support war super freundlich."
    },
    {
        "name": "Lina van der Veer",
        "rating": 5,
        "gender": "female",
        "date": "2024-08-02",
        "review": "Bester Shop! Ich habe noch nie so hochwertige und nachhaltige Produkte zu diesen Preisen gesehen. Alles lief perfekt ab."
    },
    {
        "name": "Astrid Bakker",
        "rating": 5,
        "gender": "female",
        "date": "03.07.2021",
        "eloquence_level": 1,
        "review": "Tolle Qualität! Kam schnell an. Perfekt!"
    },
    {
        "name": "Romina López",
        "rating": 5,
        "gender": "female",
        "date": "19.10.2021",
        "eloquence_level": 2,
        "review": "Die Verpackung ist wunderschön und der Service erstklassig. Sehr zufrieden!"
    },
    {
        "name": "Mathilde Rousseau",
        "rating": 4,
        "gender": "female",
        "date": "28.01.2022",
        "eloquence_level": 3,
        "review": "Bestellung kam nach 8 Tagen. Qualität ist super, Service sehr freundlich. Kleiner Punktabzug für die Wartezeit, aber dafür gab's einen Gutschein."
    },
    {
        "name": "Nina Klaassen",
        "rating": 5,
        "gender": "female",
        "date": "15.04.2022",
        "eloquence_level": 4,
        "review": "Die kostenlose Rücksendung ist fantastisch! Musste die Größe tauschen und hatte das neue Teil schon nach 4 Tagen. Vorbildlicher Service, danke!"
    },
    {
        "name": "Linnea Häkkinen",
        "rating": 5,
        "gender": "female",
        "date": "22.08.2022",
        "eloquence_level": 5,
        "review": "<strong>Hervorragender Shop!</strong><br><br>Plus:<br>- Schnelle Lieferung (3 Tage)<br>- Premium Qualität<br>- Top Kundenservice<br>- Gutes Preis-Leistungs-Verhältnis<br><br>Alles bestens, werde wieder bestellen!"
    },
    {
        "name": "Juliette Lambert",
        "rating": 5,
        "gender": "female",
        "date": "07.02.2023",
        "eloquence_level": 6,
        "review": "<strong>Achtung vor Fake-Shops!</strong><br><br>Hier bekommt man echte Qualität. Die handgemachte Verpackung ist bezaubernd und zeigt die Liebe zum Detail. Bestellt nur auf der echten Seite - es gibt viele Fakes mit den gleichen Fotos aber mieser Qualität!"
    },
    {
        "name": "Carmen Sánchez",
        "rating": 4,
        "gender": "female",
        "date": "12.06.2023",
        "eloquence_level": 7,
        "review": "<strong>Nachhaltige Mode mit Qualität</strong><br><br>Positiv:<br>- Nachhaltige Produktion<br>- Beste Qualität<br>- Gratis Retouren<br>- Bester Service<br><br>Negativ:<br>- Schwankende Lieferzeiten<br><br>Fazit: Die Wartezeit wird durch Qualität und Service mehr als ausgeglichen."
    },
    {
        "name": "Klaudia Nowak",
        "rating": 5,
        "gender": "female",
        "date": "30.11.2023",
        "eloquence_level": 8,
        "review": "<strong>Service der Spitzenklasse!</strong><br><br>Die Waren sind ihre Preise absolut wert. Als sich meine Bestellung einmal verzögerte, wurde ich sofort informiert und erhielt einen großzügigen Rabatt. Die liebevolle Verpackung macht jede Bestellung zu etwas Besonderem.<br><br>Die Lieferzeiten werden klar kommuniziert und der Support ist immer ansprechbar. Ein perfektes Einkaufserlebnis!"
    },
    {
        "name": "Céline Vandewalle",
        "rating": 5,
        "gender": "female",
        "date": "14.03.2024",
        "eloquence_level": 9,
        "review": "<strong>Nachhaltige Mode vom Feinsten - Ein ausführlicher Erfahrungsbericht</strong><br><br>Die Lieferzeiten von 1-15 Tagen sind der nachhaltigen Produktion geschuldet. Der Kundenservice ist unübertroffen - prompte Antworten, ständige Updates und faire Lösungen bei Problemen.<br><br>Die kostenlose Rücksendung ist heute keine Selbstverständlichkeit mehr, hier hebt sich der Shop deutlich von der Konkurrenz ab. Die Qualität ist durchweg überzeugend und die handgefertigte Verpackung zeigt die Sorgfalt, die in jede Bestellung fließt.<br><br>Wichtiger Hinweis: Viele Fake-Shops nutzen die gleichen Bilder. Der faire Preis hier garantiert echte Qualität und exzellenten Service."
    },
    {
        "name": "Zsofia Kovács",
        "rating": 5,
        "gender": "female",
        "date": "21.07.2024",
        "eloquence_level": 10,
        "review": "<strong>Ein Meilenstein im nachhaltigen Mode-Handel</strong><br><br>Als Stammkundin möchte ich meine langjährigen Erfahrungen teilen.<br><br>Qualität & Nachhaltigkeit: Die Artikel sind durchweg hochwertig verarbeitet und nachhaltig produziert. Der Preisaufschlag zu Fast-Fashion ist jeden Cent wert.<br><br>Versand & Verpackung: Die variierenden Lieferzeiten sind der nachhaltigen Produktion geschuldet und werden offen kommuniziert. Die handgefertigte Verpackung macht das Auspacken zum Erlebnis.<br><br>Kundenservice: Hier wird Service neu definiert. Verzögerungen werden proaktiv kommuniziert und großzügig kompensiert. Das kostenlose Retourensystem ist in Zeiten allgemeiner Rücksendegebühren bemerkenswert.<br><br>WARNUNG: Zahlreiche Fake-Shops verwenden identische Produktbilder und Dumping-Preise. Die Ware ist dann meist minderwertig oder kommt nicht an. Bestellt nur im Original-Shop!<br><br>Fazit: Für qualitäts- und nachhaltigkeitsbewusste Kunden die erste Wahl. Die flexiblen Lieferzeiten sind ein kleiner Kompromiss für garantierte Qualität und nachhaltigen Konsum."
    },
    {
        "name": "Clara Fischer",
        "rating": 5,
        "gender": "female",
        "date": "2023-02-14",
        "review": "Alles super gelaufen, gerne wieder!"
    },
    {
        "name": "Lucia Gómez",
        "rating": 5,
        "gender": "female",
        "date": "2022-05-11",
        "review": "Die Bestellung kam schneller an als erwartet, und die Qualität ist fantastisch. Vielen Dank für die großartige Erfahrung!"
    },
    {
        "name": "Maja Lund",
        "rating": 4,
        "gender": "female",
        "date": "2021-07-22",
        "review": "Tolle Produkte, aber die Verpackung war etwas beschädigt. Trotzdem insgesamt zufrieden."
    },
    {
        "name": "Pauline Lambert",
        "rating": 5,
        "gender": "female",
        "date": "2023-09-16",
        "review": "Ich liebe die nachhaltige Philosophie! Der kostenlose Rückversand ist ein echter Pluspunkt, und ich bin mit meinem Einkauf sehr glücklich."
    },
    {
        "name": "Ewa Zielinska",
        "rating": 5,
        "gender": "female",
        "date": "2022-10-03",
        "review": "Nachhaltig, hochwertig, und der Kundenservice ist erstklassig. Hier werde ich sicher noch öfter einkaufen."
    },
    {
        "name": "Astrid van Loon",
        "rating": 5,
        "gender": "female",
        "date": "2024-03-28",
        "review": "<strong>Eine wirklich außergewöhnliche Erfahrung!</strong><br>Von der Bestellung bis zur Lieferung war alles durchdacht und professionell. Die Verpackung war liebevoll gestaltet, und der Rückversand bei einer falschen Größe war super unkompliziert. Ich habe mich wirklich wertgeschätzt gefühlt."
    },
    {
        "name": "Isabelle Dubois",
        "rating": 4,
        "gender": "female",
        "date": "2022-12-04",
        "review": "Ein bisschen längere Lieferzeit, aber dafür tolle Produkte. Der Kundenservice war freundlich und hilfsbereit!"
    },
    {
        "name": "Katrin Svensson",
        "rating": 5,
        "gender": "female",
        "date": "2023-06-30",
        "review": "Ich bin begeistert! Der Kundenservice hat mir schnell geholfen, und die Produkte sind hochwertig und nachhaltig."
    },
    {
        "name": "Anna Verbeek",
        "rating": 5,
        "gender": "female",
        "date": "2024-05-10",
        "review": "Das kostenlose Rücksendesystem ist einfach genial. Ich musste einmal umtauschen, und es ging total schnell und problemlos. Einfach top!"
    },
    {
        "name": "Viktoria Novakova",
        "rating": 5,
        "gender": "female",
        "date": "2023-08-18",
        "review": "Der beste Shop, den ich kenne! Die Qualität der Produkte ist unschlagbar, und ich schätze den hervorragenden Kundenservice sehr. Weiter so!"
    },
  {
        "name": "Amelie Bertrand",
        "rating": 4,
        "gender": "female",
        "date": "2021-08-10",
        "review": "Ein bisschen Geduld bei der Lieferung nötig, aber die Qualität und der Kundenservice machen alles wett."
    },
    {
        "name": "Lina Forsberg",
        "rating": 5,
        "gender": "female",
        "date": "2023-12-03",
        "review": "Ich habe schon öfter bestellt, und jedes Mal bin ich begeistert. Besonders die handgemachte Verpackung ist ein Highlight."
    },
    {
        "name": "Ingrid Jansen",
        "rating": 5,
        "gender": "female",
        "date": "11.06.2021",
        "eloquence_level": 1,
        "review": "Top Qualität und schnelle Lieferung! Perfekt!"
    },
    {
        "name": "Rosa Muñoz",
        "rating": 5,
        "gender": "female",
        "date": "25.09.2021",
        "eloquence_level": 2,
        "review": "Liebevolle Verpackung und erstklassiger Service. Bin total begeistert."
    },
    {
        "name": "Sophie Martin",
        "rating": 4,
        "gender": "female",
        "date": "07.01.2022",
        "eloquence_level": 3,
        "review": "Lieferung nach 11 Tagen, aber der Support hat super kommuniziert. Qualität ist sehr gut, Wartezeit wurde mit Gutschein entschädigt."
    },
    {
        "name": "Eva de Vries",
        "rating": 5,
        "gender": "female",
        "date": "19.04.2022",
        "eloquence_level": 4,
        "review": "Kostenloser Rückversand ist klasse! Größentausch war problemlos und der neue Artikel kam super schnell. Vorbildlicher Service!"
    },
    {
        "name": "Aino Mäkelä",
        "rating": 5,
        "gender": "female",
        "date": "14.08.2022",
        "eloquence_level": 5,
        "review": "<strong>Sehr empfehlenswert!</strong><br><br>Positiv:<br>- Lieferung in 3 Tagen<br>- Beste Qualität<br>- Super Support<br>- Fairer Preis<br><br>Absolut zufrieden, bestelle sicher wieder!"
    },
    {
        "name": "Camille Leroy",
        "rating": 5,
        "gender": "female",
        "date": "02.01.2023",
        "eloquence_level": 6,
        "review": "<strong>Echter Premium-Shop!</strong><br><br>Nach einigen Enttäuschungen mit Fake-Shops endlich das Original gefunden. Die handgemachte Verpackung ist ein Traum. Achtung vor den vielen Fakes mit den gleichen Fotos - hier gibt's die echte Qualität!"
    },
    {
        "name": "Isabel Torres",
        "rating": 4,
        "gender": "female",
        "date": "30.06.2023",
        "eloquence_level": 7,
        "review": "<strong>Mode mit Verantwortung</strong><br><br>Pro:<br>- Nachhaltig produziert<br>- Premium Qualität<br>- Kostenlose Retoure<br>- Top Service<br><br>Contra:<br>- Lieferzeit variiert<br><br>Fazit: Die Wartezeit nehme ich für diese Qualität gerne in Kauf."
    },
    {
        "name": "Zofia Pawlak",
        "rating": 5,
        "gender": "female",
        "date": "17.11.2023",
        "eloquence_level": 8,
        "review": "<strong>Außergewöhnlicher Service!</strong><br><br>Die Qualitätsprodukte sind jeden Euro wert. Bei einer verspäteten Lieferung wurde ich sofort informiert und großzügig entschädigt. Die handgemachte Verpackung zeigt die besondere Sorgfalt.<br><br>Transparente Kommunikation und immer erreichbarer Support. Einfach perfekt!"
    },
    {
        "name": "Marie-Anne Desmet",
        "rating": 5,
        "gender": "female",
        "date": "08.03.2024",
        "eloquence_level": 9,
        "review": "<strong>Nachhaltige Mode vom Feinsten - Detaillierter Erfahrungsbericht</strong><br><br>Die Lieferzeiten zwischen 1-15 Tagen sind der nachhaltigen Produktion geschuldet. Der Kundenservice ist einmalig - schnelle Antworten, kontinuierliche Updates und faire Problemlösungen.<br><br>Kostenlose Retouren sind heute selten geworden, hier hebt sich der Shop ab. Die Qualität ist durchweg überzeugend und die handgefertigte Verpackung macht jede Bestellung einzigartig.<br><br>Wichtig: Vorsicht vor Fake-Shops mit kopierten Bildern. Der faire Preis hier garantiert echte Qualität."
    },
    {
        "name": "Katalin Nagy",
        "rating": 5,
        "gender": "female",
        "date": "22.07.2024",
        "eloquence_level": 10,
        "review": "<strong>Leuchtturm der nachhaltigen Mode</strong><br><br>Als treue Kundin möchte ich meine Erfahrungen ausführlich teilen.<br><br>Qualität & Nachhaltigkeit: Absolut hochwertig und nachhaltig produziert. Der Aufpreis zu Fast-Fashion ist gerechtfertigt.<br><br>Versand & Verpackung: Lieferzeiten variieren durch nachhaltige Produktion, werden aber transparent kommuniziert. Die handgefertigte Verpackung ist ein besonderes Highlight.<br><br>Kundenservice: Hier wird Geschichte geschrieben. Verzögerungen werden proaktiv kommuniziert und großzügig kompensiert. Das kostenlose Retourensystem ist in Zeiten der Gebührenpflicht bemerkenswert.<br><br>WARNUNG: Viele Fake-Shops nutzen identische Produktbilder und Lockpreise. Die Ware ist meist minderwertig oder kommt nicht an. Kauft nur im Original-Shop!<br><br>Fazit: Für nachhaltigkeitsbewusste Menschen die absolute Top-Adresse. Die flexiblen Lieferzeiten sind ein kleiner Preis für garantierte Qualität und nachhaltigen Konsum."
    },
    {
        "name": "Maria Schneider",
        "rating": 5,
        "gender": "female",
        "date": "2023-09-10",
        "review": "Schnelle Lieferung und alles wie erwartet. Top!"
    },
    {
        "name": "Isabel Romero",
        "rating": 5,
        "gender": "female",
        "date": "2022-11-25",
        "review": "Die Qualität der Produkte hat mich überzeugt, und der Kundenservice ist einfach spitze!"
    },
    {
        "name": "Annika Virtanen",
        "rating": 4,
        "gender": "female",
        "date": "2021-06-30",
        "review": "Schöner Shop, aber die Lieferung war langsamer als gedacht. Trotzdem: empfehlenswert."
    },
    {
        "name": "Lea Van de Berg",
        "rating": 5,
        "gender": "female",
        "date": "2023-07-20",
        "review": "Einfach perfekt! Die liebevoll verpackte Lieferung war das Highlight meines Tages."
    },
    {
        "name": "Ewa Malinowska",
        "rating": 5,
        "gender": "female",
        "date": "2024-03-09",
        "review": "<strong>Ich bin begeistert!</strong><br>Die Verpackung ist so detailreich gestaltet, die Produkte hochwertig und der Support wirklich schnell. Ein Erlebnis, das man so selten findet."
    },
    {
        "name": "Sofie Janssens",
        "rating": 4,
        "gender": "female",
        "date": "2022-04-14",
        "eloquence_level": 7,
        "review": "Lieferzeit war länger als gedacht, aber der Umtausch war unkompliziert. Ich werde trotzdem wieder bestellen."
    },
    {
        "name": "Magdalena Szewczyk",
        "rating": 5,
        "gender": "female",
        "date": "2023-01-05",
        "eloquence_level": 8,
        "review": "Einfach großartig! Kostenloser Rückversand und immer freundlicher Support – so macht Online-Shopping Spaß."
    },
    {
        "name": "Céline Rousseau",
        "rating": 5,
        "gender": "female",
        "date": "2024-06-12",
        "eloquence_level": 9,
        "review": "Die Kleidung ist wunderschön, die Qualität beeindruckend und die Preise absolut fair. Hier kaufe ich gerne wieder ein."
    },
    {
        "name": "Laura van Dijk",
        "rating": 5,
        "gender": "female",
        "date": "2022-08-17",
        "review": "Alles perfekt! Die Bestellung war super schnell da, und der Rückversand bei einer falschen Größe war total einfach."
    },
    {
        "name": "Nina Horváth",
        "rating": 5,
        "gender": "female",
        "date": "2023-03-24",
        "review": "Toller Service, nachhaltige Produkte und faire Preise – genau das, was ich gesucht habe. Danke!"
    },
    {
        "name": "Freya Jensen",
        "rating": 5,
        "date": "09.07.2021",
        "eloquence_level": 1,
        "review": "Perfekte Qualität! Schnelle Lieferung! Sehr zufrieden!"
    },
    {
        "name": "Beatriz Navarro",
        "rating": 5,
        "date": "14.10.2021",
        "eloquence_level": 2,
        "review": "Die Verpackung ist traumhaft schön. Support ist super nett. Gerne wieder!"
    },
    {
        "name": "Élise Dupont",
        "rating": 4,
        "date": "26.01.2022",
        "eloquence_level": 3,
        "review": "Lieferung kam nach 7 Tagen. Support hat super informiert und einen Rabattcode geschickt. Qualität ist sehr gut, nur die Wartezeit etwas lang."
    },
    {
        "name": "Luna van Rijn",
        "rating": 5,
        "gender": "female",
        "date": "03.05.2022",
        "eloquence_level": 4,
        "review": "Die kostenlose Retoure ist ein absoluter Pluspunkt! Größentausch war super einfach und die neue Lieferung kam nach 3 Tagen. Toller Service!"
    },
    {
        "name": "Minna Korhonen",
        "rating": 5,
        "gender": "female",
        "date": "19.09.2022",
        "eloquence_level": 5,
        "review": "<strong>Hervorragender Shop!</strong><br><br>Plus:<br>- Express-Lieferung (2 Tage)<br>- Top Qualität<br>- Exzellenter Support<br>- Gutes Preis-Leistungs-Verhältnis<br><br>Rundum zufrieden!"
    },
    {
        "name": "Léonie Bernard",
        "rating": 5,
        "gender": "female",
        "date": "08.02.2023",
        "eloquence_level": 6,
        "review": "<strong>Original vs. Fakes!</strong><br><br>Endlich authentische Qualität gefunden. Die handgemachte Verpackung ist ein Traum. Finger weg von den vielen Fake-Shops mit kopierten Bildern - hier gibt's das echte Produkt!"
    },
    {
        "name": "Lucia Morales",
        "rating": 4,
        "gender": "female",
        "date": "11.06.2023",
        "eloquence_level": 7,
        "review": "<strong>Nachhaltig & Hochwertig</strong><br><br>Positiv:<br>- Nachhaltige Herstellung<br>- Premium Qualität<br>- Gratis Retouren<br>- Erstklassiger Service<br><br>Negativ:<br>- Schwankende Lieferzeit<br><br>Fazit: Die Wartezeit ist die Qualität definitiv wert."
    },


  

{
        "name": "Wanda Kowalska",
        "rating": 5,
        "gender": "female",
        "date": "25.11.2023",
        "eloquence_level": 8,
        "review": "<strong>Service Deluxe!</strong><br><br>Die Qualität rechtfertigt den Preis absolut. Als sich meine Lieferung verzögerte, kam sofort eine Info und ein großzügiger Gutschein. Die handgemachte Verpackung zeigt die Liebe zum Detail.<br><br>Vorbildliche Kommunikation und Support immer erreichbar. Beispielhaft!"
    },
    {
        "name": "Fleur van der Meer",
        "rating": 5,
        "gender": "female",
        "date": "02.03.2024",
        "eloquence_level": 9,
        "review": "<strong>Premium Nachhaltigkeit - Ein ausführlicher Bericht</strong><br><br>Lieferzeiten von 1-15 Tagen zeigen die nachhaltige Produktion. Der Service ist unübertroffen - blitzschnelle Antworten, laufende Updates und faire Lösungen.<br><br>Kostenlose Retouren sind heute einzigartig. Die Qualität ist makellos und die handgefertigte Verpackung macht jede Bestellung besonders.<br><br>Wichtig: Viele Fake-Shops mit kopierten Bildern unterwegs. Der faire Preis hier garantiert echte Qualität."
    },
    {
        "name": "Réka Molnár",
        "rating": 5,
        "gender": "female",
        "date": "18.08.2024",
        "eloquence_level": 10,
        "review": "<strong>Nachhaltigkeit neu definiert</strong><br><br>Als Stammkundin teile ich meine umfangreiche Erfahrung.<br><br>Qualität & Nachhaltigkeit: Hochwertig und nachhaltig produziert. Der Aufpreis zu Fast-Fashion absolut gerechtfertigt.<br><br>Versand & Verpackung: Variable Lieferzeiten durch nachhaltige Produktion, aber transparent kommuniziert. Die handgefertigte Verpackung macht jede Bestellung zum Erlebnis.<br><br>Kundenservice: Setzt neue Maßstäbe. Verzögerungen werden proaktiv kommuniziert und großzügig kompensiert. Kostenloses Retourensystem ist heute einzigartig.<br><br>WARNUNG: Zahlreiche Fake-Shops mit identischen Bildern und Dumpingpreisen. Minderwertige oder keine Lieferung garantiert. Nur hier im Original-Shop bestellen!<br><br>Fazit: Für nachhaltigkeitsbewusste Menschen alternativlos. Die flexiblen Lieferzeiten sind ein kleiner Preis für garantierte Qualität und nachhaltigen Konsum."
    },
    {
        "name": "Hanna Müller",
        "rating": 5,
        "gender": "female",
        "date": "2023-11-02",
        "review": "Alles super, gerne wieder!"
    },
    {
        "name": "Lucía Pérez",
        "rating": 5,
        "gender": "female",
        "date": "2022-10-18",
        "review": "Die Produkte sind wunderschön und genau wie beschrieben. Ich bin sehr zufrieden."
    },
    {
        "name": "Noora Heikkilä",
        "rating": 4,
        "gender": "female",
        "date": "2024-01-14",
        "review": "Die Lieferzeit war länger als erhofft, aber die Qualität ist top. Gerne wieder!"
    },
    {
        "name": "Amélie Lefèvre",
        "rating": 5,
        "gender": "female",
        "date": "2021-09-21",
        "review": "Der beste Online-Shop, den ich kenne! Nachhaltig, zuverlässig und mit einem tollen Service."
    },
    {
        "name": "Karolina Dabrowska",
        "rating": 5,
        "gender": "female",
        "date": "2023-05-06",
        "review": "Ich liebe die liebevoll gestaltete Verpackung und die hochwertige Qualität der Produkte. Einfach perfekt!"
    },
    {
        "name": "Sanne Visser",
        "rating": 4,
        "gender": "female",
        "date": "2022-02-03",
        "review": "Schöner Shop mit tollen Produkten, aber die Lieferung hat länger gedauert als erwartet."
    },
    {
        "name": "Gabriela Kovács",
        "rating": 5,
        "gender": "female",
        "date": "2024-07-01",
        "review": "<strong>Ich bin beeindruckt!</strong><br>Die Qualität der Produkte ist wirklich überragend, und der kostenlose Rückversand ist ein echter Pluspunkt. Vielen Dank für diesen tollen Service!"
    },
    {
        "name": "Elisabeth Van Loo",
        "rating": 5,
        "gender": "female",
        "date": "2023-06-10",
        "review": "Ich hatte eine Frage zum Versand und der Kundenservice hat sofort geantwortet. Alles lief problemlos!"
    },
    {
        "name": "Natalia Wiśniewska",
        "rating": 5,
        "gender": "female",
        "date": "2024-08-29",
        "review": "Die Produkte sind einfach wunderschön, und der Service ist unübertroffen. Ich bin sehr zufrieden!"
    },
    {
        "name": "Julia De Groot",
        "rating": 5,
        "gender": "female",
        "date": "2022-11-19",
        "review": "Von der Bestellung bis zur Lieferung alles einwandfrei. Gerne wieder!"
    },
    {
        "name": "Signe Andersen",
        "rating": 5,
        "gender": "female",
        "date": "17.06.2021",
        "eloquence_level": 1,
        "review": "Tolle Qualität, mega schnelle Lieferung! Super!"
    },
    {
        "name": "Raquel Jiménez",
        "rating": 5,
        "gender": "female",
        "date": "29.09.2021",
        "eloquence_level": 2,
        "review": "Die Verpackung ist traumhaft schön. Support ist super nett. Gerne wieder!"
    },
    {
        "name": "Julie Renard",
        "rating": 4,
        "gender": "female",
        "date": "12.01.2022",
        "eloquence_level": 3,
        "review": "Bestellung brauchte 10 Tage. Support sehr nett, informativ und hat einen Gutschein geschickt. Qualität super, Lieferzeit etwas lang."
    },
    {
        "name": "Sanne de Boer",
        "rating": 5,
        "gender": "female",
        "date": "25.04.2022",
        "eloquence_level": 4,
        "review": "Kostenloser Rückversand ist ein Traum! Größentausch war super einfach und die neue Lieferung kam blitzschnell. Sehr professionell!"
    },
    {
        "name": "Erika Järvinen",
        "rating": 5,
        "gender": "female",
        "date": "03.08.2022",
        "eloquence_level": 5,
        "review": "<strong>Erstklassiger Shop!</strong><br><br>Plus:<br>- Lieferung in 4 Tagen<br>- Spitzenqualität<br>- Perfekter Support<br>- Faire Preise<br><br>Einfach top!"
    },
    {
        "name": "Amélie Durand",
        "rating": 5,
        "gender": "female",
        "date": "16.01.2023",
        "eloquence_level": 6,
        "review": "<strong>Echt vs. Fake!</strong><br><br>Ein Shop mit echter Qualität gefunden. Handgemachte Verpackung ist wunderschön. Vorsicht vor den vielen Fake-Shops mit gleichen Bildern - hier bekommt ihr das Original!"
    },
    {
        "name": "Marisol Pérez",
        "rating": 4,
        "gender": "female",
        "date": "22.05.2023",
        "eloquence_level": 7,
        "review": "<strong>Qualität trifft Nachhaltigkeit</strong><br><br>Pro:<br>- Nachhaltig produziert<br>- Hochwertige Qualität<br>- Gratis Retouren<br>- Erstklassiger Service<br><br>Contra:<br>- Lieferzeit variabel<br><br>Fazit: Die Wartezeit wird durch Qualität wettgemacht."
    },
    {
        "name": "Aleksandra Dąbrowska",
        "rating": 5,
        "gender": "female",
        "date": "09.12.2023",
        "eloquence_level": 8,
        "review": "<strong>Service der Extraklasse!</strong><br><br>Qualität rechtfertigt jeden Cent. Bei Lieferverzögerung sofort informiert und großzügig entschädigt. Handgemachte Verpackung zeigt besondere Aufmerksamkeit.<br><br>Perfekte Kommunikation und Support immer verfügbar. Besser geht's nicht!"
    },
    {
        "name": "Louise van den Berg",
        "rating": 5,
        "gender": "female",
        "date": "14.04.2024",
        "eloquence_level": 9,
        "review": "<strong>Nachhaltiger Shopping-Traum - Meine Erfahrung</strong><br><br>Lieferzeiten 1-15 Tage spiegeln nachhaltige Produktion wider. Service einzigartig - prompte Antworten, stetige Updates, faire Lösungen.<br><br>Kostenlose Retoure heute besonders. Qualität überzeugend, handgefertigte Verpackung macht's persönlich.<br><br>Achtung: Viele Fake-Shops mit gleichen Bildern. Fairer Preis hier garantiert echte Qualität."
    },
    {
        "name": "Eszter Szabó",
        "rating": 5,
        "gender": "female",
        "date": "25.07.2024",
        "eloquence_level": 10,
        "review": "<strong>Vorreiter nachhaltiger Mode</strong><br><br>Als Langzeitkundin teile ich meine Erkenntnisse.<br><br>Qualität & Nachhaltigkeit: Erstklassig verarbeitet, nachhaltig produziert. Preisaufschlag zu Fast-Shopping gerechtfertigt.<br><br>Versand & Verpackung: Lieferzeiten variieren durch Nachhaltigkeit, aber transparent kommuniziert. Handgefertigte Verpackung macht's besonders.<br><br>Service: Revolutionär. Verzögerungen proaktiv kommuniziert, großzügig kompensiert. Kostenloses Retourensystem einzigartig.<br><br>Fazit: Für nachhaltigkeitsbewusste Kunden die absolute Top-Adresse. Faire Preise garantieren echte Qualität."
    },
    {
        "name": "Anna Bauer",
        "rating": 5,
        "gender": "female",
        "date": "2023-04-20",
        "review": "Schnelle Lieferung und tolle Qualität. Ich bin begeistert!"
    },
    {
        "name": "Sofia Moreno",
        "rating": 5,
        "gender": "female",
        "date": "2022-09-12",
        "review": "Alles hat super geklappt, und die Produkte sind genauso, wie ich es mir vorgestellt habe."
    },
    {
        "name": "Milla Väisänen",
        "rating": 4,
        "gender": "female",
        "date": "2021-08-15",
        "review": "Qualität ist top, aber die Lieferung hat fast zwei Wochen gedauert. Trotzdem bestelle ich wieder!"
    },
    {
        "name": "Louise Dubois",
        "rating": 5,
        "gender": "female",
        "date": "2023-11-07",
        "review": "Sehr guter Service, schnelle Antworten auf Anfragen und eine hervorragende Qualität. Bin rundum zufrieden."
    },
    {
        "name": "Magda Kowalczyk",
        "rating": 5,
        "gender": "female",
        "date": "2023-06-25",
        "review": "Die Verpackung ist so hübsch und nachhaltig – wirklich eine Freude, hier zu bestellen!"
    },
    {
        "name": "Emma Verhoeven",
        "rating": 4,
        "gender": "female",
        "date": "2022-03-14",
        "review": "Schöne Produkte, aber die Lieferung war etwas langsam. Dennoch ein sehr guter Shop."
    },
    {
        "name": "Petra Horáková",
        "rating": 5,
        "gender": "female",
        "date": "2024-02-27",
        "review": "<strong>Fantastischer Service!</strong><br>Ich habe versehentlich die falsche Größe bestellt, aber der Umtausch war super einfach und schnell. Die Qualität ist wirklich hervorragend!"
    },
    {
        "name": "Anouk Janssen",
        "rating": 5,
        "gender": "female",
        "date": "2023-12-02",
        "review": "Einfach ein toller Shop. Alles lief reibungslos, und die Produkte sind großartig!"
    },


{
    "name": "Thomas Weber",
    "rating": 5,
    "gender": "male",
    "date": "15.07.2021",
    "eloquence": 1,
    "review": "Top Shop, gerne wieder!"
  },
  {
    "name": "Michael Schmidt",
    "rating": 4,
    "gender": "male",
    "date": "03.11.2021",
    "eloquence": 2,
    "review": "Schnelle Lieferung und gute Qualität. Kann ich nur empfehlen."
  },
  {
    "name": "Hans-Joachim Müller",
    "rating": 5,
    "gender": "male",
    "date": "22.03.2022",
    "eloquence": 3,
    "review": "Der Kundenservice ist wirklich erstklassig. Hatte eine Frage zur Lieferzeit und bekam sofort eine ausführliche Antwort. Die Ware kam pünktlich an."
  },
  {
    "name": "Pierre Dubois",
    "rating": 5,
    "gender": "male",
    "date": "14.08.2022",
    "eloquence": 4,
    "review": "Als langjähriger Kunde muss ich sagen - die Qualität ist konstant gut geblieben. Der kostenlose Rückversand ist in der heutigen Zeit wirklich ein großer Pluspunkt. <br>Besonders beeindruckt hat mich die liebevolle Verpackung."
  },
  {
    "name": "Klaus-Dieter Hoffmann",
    "rating": 5,
    "gender": "male",
    "date": "29.01.2023",
    "eloquence": 5,
    "review": "<strong>Positiv:</strong><br>- Schnelle Lieferung (bei mir nur 3 Tage)<br>- Erstklassige Qualität<br>- Faire Preise<br><br>Würde jederzeit wieder hier bestellen!"
  },
  {
    "name": "Alessandro Romano",
    "rating": 4,
    "gender": "male",
    "date": "17.05.2023",
    "eloquence": 6,
    "review": "Meine erste Bestellung hier und ich bin sehr positiv überrascht! Die Verpackung war wunderschön handgefertigt, man merkt die Liebe zum Detail. <br><br>Ein kleiner Tipp an alle: Vorsicht vor Fake-Shops in sozialen Medien, die die gleichen Bilder verwenden. Hier bei Prime-Moda bekommt man das Original in bester Qualität."
  },
   {
    "name": "Stefan Kovač",
    "rating": 5,
    "gender": "male",
    "date": "21.10.2021",
    "eloquence": 1,
    "review": "Sehr zufrieden mit meiner Bestellung! Komme wieder."
  },
  {
    "name": "Lars Andersen",
    "rating": 4,
    "gender": "male",
    "date": "08.02.2022",
    "eloquence": 2,
    "review": "Toller Shop, super Verpackung. Die Qualität stimmt einfach."
  },
  {
    "name": "Björn Lindholm",
    "rating": 5,
    "gender": "male",
    "date": "19.05.2022",
    "eloquence": 3,
    "review": "War skeptisch wegen der Lieferzeit, aber der Kundenservice hat mich super auf dem Laufenden gehalten. Qualität ist erstklassig."
  },
  {
    "name": "Henri Dupont",
    "rating": 5,
    "gender": "male",
    "date": "30.09.2022",
    "eloquence": 4,
    "review": "Diese handgemachte Verpackung ist wirklich etwas Besonderes! <br>Die Qualität der Artikel ist super und der Service erstklassig. Bin begeistert vom kostenlosen Rückversand."
  },
  {
    "name": "Ricardo Martinez",
    "rating": 4,
    "gender": "male",
    "date": "15.03.2023",
    "eloquence": 5,
    "review": "<strong>Mein Eindruck:</strong><br>- Nachhaltige Produktion<br>- Fantastischer Kundenservice<br>- Faire Preise<br>- Liebevolle Verpackung<br><br>Ein kleiner Abzug wegen der Lieferzeit, aber das ist es wert!"
  },
  {
    "name": "Felix van den Berg",
    "rating": 5,
    "gender": "male",
    "date": "27.06.2023",
    "eloquence": 6,
    "review": "Als regelmäßiger Online-Shopper muss ich sagen: Hier stimmt einfach das Gesamtpaket! <br><br>Die Qualität ist hervorragend, der Service erstklassig und die kostenlose Rücksendung ist heutzutage wirklich keine Selbstverständlichkeit mehr. Besonders beeindruckt hat mich die handgefertigte Verpackung - man merkt die Liebe zum Detail."
  },
  {
    "name": "Gustav Eriksson",
    "rating": 5,
    "gender": "male",
    "date": "12.11.2023",
    "eloquence": 7,
    "review": "<strong>Meine Erfahrung nach mehreren Bestellungen:</strong><br><br>Der Shop überzeugt auf ganzer Linie. Die Lieferzeiten variieren zwar, aber man wird immer bestens informiert. Die nachhaltige Produktion spiegelt sich in der Qualität wider. <br><br>Besonders positiv: Als es einmal länger dauerte, erhielt ich einen großzügigen Rabatt. Das nenne ich Kundenservice!"
  },
  {
    "name": "Matthias Bauer",
    "rating": 4,
    "gender": "male",
    "date": "04.01.2024",
    "eloquence": 8,
    "review": "<strong>Detaillierte Bewertung:</strong><br><br>Nach einem Jahr als Kunde hier meine Einschätzung: Die Qualität ist durchweg hochwertig, die Verpackung liebevoll handgefertigt. Der Kundenservice ist vorbildlich - schnelle Antworten, proaktive Updates. <br><br>Wichtig: Finger weg von den Fake-Shops in sozialen Medien! Hier bekommt man das Original in bester Qualität. <br><br><strong>Fazit:</strong> Die manchmal längeren Lieferzeiten sind der einzige kleine Kritikpunkt, aber dafür ist die Qualität top!"
  },
  {
    "name": "Antoine Leroy",
    "rating": 5,
    "gender": "male",
    "date": "19.04.2024",
    "eloquence": 9,
    "review": "<strong>Ausführliche Bewertung eines zufriedenen Kunden:</strong><br><br>Nach zahlreichen Bestellungen kann ich diesen Shop wärmstens empfehlen. <br><br><strong>Highlights:</strong><br>- Die handgefertigte Verpackung ist ein echtes Erlebnis<br>- Erstklassige Qualität durch nachhaltige Produktion<br>- Vorbildlicher Kundenservice mit proaktiver Kommunikation<br>- Kostenloser Rückversand (keine Selbstverständlichkeit mehr!)<br><br><strong>Wichtiger Hinweis:</strong> Es gibt leider viele Fake-Shops, die die gleichen Bilder verwenden. Bestellt nur hier im Original-Shop! <br><br>Die Lieferzeiten können variieren, aber dafür bekommt man Qualität, die überzeugt. Der Support geht bei Verzögerungen sehr kulant mit Rabatten um. <br><br><strong>Fazit:</strong> Ein Shop mit Herz und Verstand!"
  },
  {
    "name": "Maximilian Huber",
    "rating": 5,
    "gender": "male",
    "date": "01.08.2024",
    "eloquence": 10,
    "review": "<strong>Umfassende Analyse nach zwei Jahren als Kunde:</strong><br><br><strong>Service & Kommunikation:</strong><br>Der Kundenservice setzt neue Maßstäbe. Proaktive Updates, schnelle Reaktionen und kulante Lösungen bei Verzögerungen. Die transparente Kommunikation schafft Vertrauen. <br><br><strong>Qualität & Nachhaltigkeit:</strong><br>Die nachhaltige Produktion rechtfertigt jeden Euro. Die Qualität ist konstant hoch, und falls doch mal etwas nicht passt, ist der kostenlose Rückversand ein echter Pluspunkt. <br><br><strong>Verpackung & Lieferung:</strong><br>Die handgefertigte Verpackung zeigt die Wertschätzung gegenüber den Kunden. Die Lieferzeiten von 1-15 Tagen sind der nachhaltigen Produktion geschuldet und werden transparent kommuniziert. <br><br><strong>Besondere Erlebnisse:</strong><br>Bei einer längeren Lieferzeit erhielt ich nicht nur einen großzügigen Rabatt, sondern durfte die Bestellung sogar kostenfrei behalten. Das ist Kundenservice par excellence! <br><br><strong>Warnung:</strong><br>Vorsicht vor Fake-Shops in sozialen Medien und Suchmaschinen! Sie kopieren die Bilder, liefern aber minderwertige Ware oder gar nicht. Der Preisunterschied zum Original ist die Qualität absolut wert. <br><br><strong>Fazit:</strong><br>Prime-Moda vereint alles, was einen exzellenten Online-Shop ausmacht: Nachhaltigkeit, Qualität, herausragenden Service und Kundenorientierung. Die gelegentlich längeren Lieferzeiten sind ein kleiner Preis für diese Gesamtleistung. <br><br>Für alle, die Wert auf echte Qualität und nachhaltigen Konsum legen: Hier seid ihr genau richtig!"
  },
  {
  "name": "Niklas Virtanen",
  "rating": 5,
  "gender": "male",
  "date": "03.08.2021",
  "eloquence": 1,
  "review": "Perfekter Service, super Ware!"
},
{
  "name": "Robert Kowalski",
  "rating": 4,
  "gender": "male",
  "date": "17.11.2021",
  "eloquence": 2,
  "review": "Gute Qualität und toller Service. Die Verpackung ist wirklich schön."
},
{
  "name": "Pedro Silva",
  "rating": 5,
  "gender": "male",
  "date": "25.02.2022",
  "eloquence": 3,
  "review": "Die Lieferung kam schneller als erwartet. Kundenservice ist super freundlich und die Qualität stimmt auch."
},
{
  "name": "Erik Jansson",
  "rating": 5,
  "gender": "male",
  "date": "14.06.2022",
  "eloquence": 4,
  "review": "Bin begeistert von der Qualität! <br>Der kostenlose Rückversand ist wirklich klasse und die handgemachte Verpackung macht einfach Freude."
},
{
  "name": "Martin Dvorak",
  "rating": 4,
  "gender": "male",
  "date": "30.09.2022",
  "eloquence": 5,
  "review": "<strong>Kurze Zusammenfassung:</strong><br>- Sehr gute Qualität<br>- Netter Kundenservice<br>- Schöne Verpackung<br>- Faire Preise<br><br>Kleiner Punktabzug für die Lieferzeit, aber sonst top!"
},
{
  "name": "Louis Bernard",
  "rating": 5,
  "gender": "male",
  "date": "12.01.2023",
  "eloquence": 6,
  "review": "Möchte gerne eine wichtige Warnung aussprechen: Aufgepasst vor den vielen Fake-Shops! Hier im Original-Shop bekommt man echte Qualität und einen erstklassigen Service. <br><br>Die handgemachte Verpackung ist ein echtes Highlight und der kostenlose Rückversand in der heutigen Zeit Gold wert."
},
{
  "name": "Victor Peeters",
  "rating": 5,
  "gender": "male",
  "date": "28.04.2023",
  "eloquence": 7,
  "review": "<strong>Meine Erfahrungen im Detail:</strong><br><br>Habe nun mehrfach hier bestellt und bin jedes Mal aufs Neue begeistert. Die nachhaltige Produktion merkt man der Qualität an. Der Kundenservice ist vorbildlich - bei einer verzögerten Lieferung wurde ich proaktiv informiert und erhielt sogar einen Rabatt. <br><br>Die handgefertigte Verpackung macht jede Lieferung zu etwas Besonderem."
},
{
  "name": "Christoph Wagner",
  "rating": 4,
  "gender": "male",
  "date": "09.10.2023",
  "eloquence": 8,
  "review": "<strong>Ausführliche Bewertung:</strong><br><br>Nach einem Jahr als Kunde kann ich nur Positives berichten. Die Qualität ist durchweg hochwertig, der Service erstklassig. <br><br>Besonders beeindruckend finde ich den Umgang mit Verzögerungen - man wird stets informiert und kulant entschädigt. Der kostenlose Rückversand ist heute keine Selbstverständlichkeit mehr. <br><br><strong>Wichtig:</strong> Lasst euch nicht von Fake-Shops täuschen, die die gleichen Bilder verwenden. Hier bekommt ihr das Original in bester Qualität!"
},
{
  "name": "Andreas Papadopoulos",
  "rating": 5,
  "gender": "male",
  "date": "15.03.2024",
  "eloquence": 9,
  "review": "<strong>Detaillierte Bewertung eines Stammkunden:</strong><br><br>Als langjähriger Kunde möchte ich besonders den nachhaltigen Aspekt hervorheben. <br><br><strong>Positiv:</strong><br>- Außergewöhnlich gute Qualität<br>- Herausragender Kundenservice<br>- Handgefertigte Verpackung mit Liebe zum Detail<br>- Kostenloser Rückversand<br>- Nachhaltige Produktion<br><br><strong>Wichtiger Hinweis:</strong><br>Vorsicht vor Fake-Shops in sozialen Medien! Die Qualitätsunterschiede sind enorm. <br><br>Die Lieferzeiten können variieren, aber dafür wird man stets auf dem Laufenden gehalten. Bei einer Verzögerung erhielt ich sogar einen großzügigen Rabatt. <br><br><strong>Fazit:</strong> Absolut empfehlenswert für alle, die Wert auf Qualität und Nachhaltigkeit legen!"
},
{
  "name": "Sebastian Fischer",
  "rating": 5,
  "gender": "male",
  "date": "22.07.2024",
  "eloquence": 10,
  "review": "<strong>Umfassende Analyse nach zahlreichen Bestellungen:</strong><br><br><strong>Qualität & Nachhaltigkeit:</strong><br>Die nachhaltige Produktion spiegelt sich in jedem Artikel wider. Ja, manchmal kostet es etwas mehr als bei der Konkurrenz, aber die Qualität rechtfertigt jeden Cent. <br><br><strong>Kundenservice & Kommunikation:</strong><br>Hier wird Kundenorientierung gelebt. Proaktive Updates, schnelle Reaktionszeiten und überaus kulante Lösungen bei Verzögerungen. Einmal erhielt ich bei einer verspäteten Lieferung sogar eine komplette Erstattung UND durfte die Artikel behalten! <br><br><strong>Verpackung & Lieferung:</strong><br>Die handgefertigte Verpackung zeigt die außergewöhnliche Sorgfalt. Die Lieferzeiten von 1-15 Tagen werden transparent kommuniziert. <br><br><strong>Rückversand & Nachhaltigkeit:</strong><br>Der kostenlose Rückversand ist in Zeiten, wo andere Shops dafür Gebühren verlangen, ein echter Mehrwert. <br><br><strong>Wichtige Warnung:</strong><br>Es gibt leider viele Fake-Shops, besonders in sozialen Medien, die die gleichen Produktbilder verwenden. Die Qualitätsunterschiede sind gravierend - spart nicht am falschen Ende! <br><br><strong>Persönliches Fazit:</strong><br>Ein Vorzeigebeispiel für modernen E-Commerce mit Fokus auf Nachhaltigkeit, Qualität und exzellentem Service. Die gelegentlich längeren Lieferzeiten sind ein kleiner Preis für diese Gesamtleistung. <br><br>Für alle, die echte Qualität suchen: Hier werdet ihr garantiert nicht enttäuscht!"
},

  {
  "name": "Luca Rossi",
  "rating": 5,
  "gender": "male",
  "date": "11.09.2021",
  "eloquence": 1,
  "review": "Genau wie beschrieben, super Service!"
},
{
  "name": "Marc Dubois",
  "rating": 4,
  "gender": "male",
  "date": "28.12.2021",
  "eloquence": 2,
  "review": "Die Qualität ist super und der Service erstklassig. Gerne wieder."
},
{
  "name": "Jan van Dijk",
  "rating": 5,
  "gender": "male",
  "date": "15.03.2022",
  "eloquence": 3,
  "review": "Tolle Verpackung, schnelle Lieferung und der Kundenservice ist wirklich spitze. Sehr empfehlenswert."
},
{
  "name": "Simon Bakker",
  "rating": 5,
  "gender": "male",
  "date": "22.07.2022",
  "eloquence": 4,
  "review": "Die handgemachte Verpackung ist ein echtes Highlight! <br>Qualität stimmt und der kostenlose Rückversand ist heutzutage wirklich keine Selbstverständlichkeit mehr."
},
{
  "name": "Oliver Kvist",
  "rating": 4,
  "gender": "male",
  "date": "09.11.2022",
  "eloquence": 5,
  "review": "<strong>Mein Eindruck:</strong><br>- Hochwertige Qualität<br>- Exzellenter Service<br>- Schöne Verpackung<br>- Kostenloser Rückversand<br><br>Ein Stern Abzug nur wegen der Lieferzeit, aber das ist es wert!"
},
{
  "name": "André Moreau",
  "rating": 5,
  "gender": "male",
  "date": "03.04.2023",
  "eloquence": 6,
  "review": "Als regelmäßiger Kunde kann ich nur warnen: Finger weg von den Fake-Shops! <br><br>Hier bekommt man echte Qualität, einen top Service und die Verpackung ist jedes Mal ein Geschenk an sich. Der kostenlose Rückversand macht das Einkaufen besonders angenehm."
},
{
  "name": "Lukas Mayer",
  "rating": 5,
  "gender": "male",
  "date": "19.08.2023",
  "eloquence": 7,
  "review": "<strong>Meine Erfahrung nach mehreren Bestellungen:</strong><br><br>Der Shop überzeugt durch Qualität und Service. Die nachhaltige Produktion merkt man den Artikeln an. Bei einer verzögerten Lieferung wurde ich nicht nur informiert, sondern erhielt auch einen großzügigen Rabatt. <br><br>Die handgefertigte Verpackung ist jedes Mal eine Freude beim Auspacken."
},
{
  "name": "Mikael Järvinen",
  "rating": 4,
  "gender": "male",
  "date": "25.01.2024",
  "eloquence": 8,
  "review": "Nach zahlreichen Bestellungen kann ich nur Positives berichten. Die Qualität ist erstklassig, der Service vorbildlich. <br><br>Besonders beeindruckend: Als eine Lieferung länger dauerte, wurde ich nicht nur proaktiv informiert, sondern erhielt auch eine Entschädigung. <br><br><strong>Wichtig:</strong> Achtet auf Fake-Shops - hier bekommt ihr das Original in bester Qualität!"
},
{
  "name": "Nicolas Lambert",
  "rating": 5,
  "gender": "male",
  "date": "12.05.2024",
  "eloquence": 9,
  "review": "Nach einem Jahr regelmäßiger Bestellungen hier mein Fazit: <br><br><strong>Positiv:</strong><br>- Hervorragende Qualität<br>- Erstklassiger Kundenservice<br>- Liebevolle, handgefertigte Verpackung<br>- Kostenloser Rückversand<br>- Nachhaltige Produktion<br><br><strong>Wichtiger Hinweis:</strong><br>Vorsicht vor den zahlreichen Fake-Shops! Der kleine Preisunterschied zum Original lohnt sich definitiv. <br><br>Die Lieferzeiten können variieren, aber die Kommunikation ist immer transparent. Bei Verzögerungen wird man mehr als fair entschädigt. <br><br><strong>Fazit:</strong> Absolut empfehlenswert!"
},
{
  "name": "Christian Weber",
  "rating": 5,
  "gender": "male",
  "date": "30.08.2024",
  "eloquence": 10,
  "review": "<strong>Umfassende Analyse eines Stammkunden:</strong><br><br><strong>Qualität & Nachhaltigkeit:</strong><br>Die nachhaltige Produktion zeigt sich in jedem Detail. Der etwas höhere Preis ist die Qualität absolut wert. <br><br><strong>Service & Kommunikation:</strong><br>Vorbildlicher Kundenservice mit proaktiven Updates. Bei Verzögerungen wird man nicht nur informiert, sondern auch großzügig entschädigt - einmal durfte ich die komplette Bestellung kostenlos behalten! <br><br><strong>Verpackung & Versand:</strong><br>Die handgefertigte Verpackung macht jede Lieferung zu etwas Besonderem. Der kostenlose Rückversand ist in der heutigen Zeit ein echter Mehrwert. <br><br><strong>Wichtige Warnung:</strong><br>Es existieren viele Fake-Shops, die die gleichen Bilder verwenden. Die Qualitätsunterschiede sind enorm - hier bekommt ihr garantiert das Original. <br><br><strong>Gesamtfazit:</strong><br>Ein Vorzeigebeispiel für modernen E-Commerce: nachhaltig, kundenorientiert und qualitätsbewusst. Die manchmal längeren Lieferzeiten werden durch den exzellenten Service mehr als ausgeglichen. <br><br>Absolute Empfehlung für alle, die Wert auf echte Qualität und nachhaltigen Konsum legen!"
},
  

    {
        "name": "Leonard Varga",
        "rating": 5,
        "gender": "male",
        "review": "Top Shop, einfach alles perfekt!"
    },
    {
        "name": "Janis Delacroix",
        "rating": 4,
        "gender": "male",
        "review": "Die Verpackung hat mir wirklich gefallen, sehr persönlich gemacht. Lieferung kam nach 10 Tagen, war aber alles in Ordnung."
    },
    {
        "name": "Mateo Król",
        "rating": 5,
        "gender": "male",
        "review": "Von der Bestellung bis zur Lieferung hat alles super geklappt. Die nachhaltige Produktion und die Qualität rechtfertigen die manchmal längeren Wartezeiten."
    },
    {
        "name": "Finn Merker",
        "rating": 4,
        "gender": "male",
        "review": "Die kostenlose Rücksendung hat mir geholfen, eine falsche Größe problemlos zu tauschen. Alles in allem ein toller Service!"
    },
    {
        "name": "Olivier Dumont",
        "rating": 5,
        "gender": "male",
        "review": "Habe den Kundenservice kontaktiert, da meine Bestellung nach 12 Tagen noch nicht da war. Der Support war unglaublich freundlich, ich bekam einen Rabatt und das Paket kam zwei Tage später an."
    },
    {
        "name": "Timo Janssen",
        "rating": 4,
        "gender": "male",
        "review": "Ein wirklich guter Shop mit tollem Kundenservice. Manchmal dauert die Lieferung länger, aber dafür stimmt die Qualität immer."
    },
    {
        "name": "Gabriel Alarcón",
        "rating": 5,
        "gender": "male",
        "review": "Die Kleidung war genau wie beschrieben, die Verpackung liebevoll gestaltet, und ich wurde ständig über den Lieferstatus informiert. Man merkt einfach, wie viel Mühe in jedem Schritt steckt. Ich habe schon oft online bestellt, aber hier hatte ich das Gefühl, wirklich geschätzt zu werden. Die Qualität ist tadellos und nachhaltig, was in dieser Preisklasse kaum zu finden ist. Weiter so!"
    },
    {
        "name": "Tomislav Novak",
        "rating": 4,
        "gender": "male",
        "review": "Ich habe schon bei anderen Shops bestellt und war oft enttäuscht. Hier war alles okay, besonders die Rücksendung lief reibungslos."
    },
    {
        "name": "Mikael Virtanen",
        "rating": 5,
        "gender": "male",
        "review": "Wirklich beeindruckender Service und hohe Qualität. Ich wurde gewarnt, nicht bei Fakes zu kaufen, und bin froh, dass ich mich für diesen Shop entschieden habe. Keine bösen Überraschungen!"
    },
    {
        "name": "Luuk Van Dijk",
        "rating": 5,
        "gender": "male",
        "review": "Ich bin absolut begeistert! Die Lieferung war schnell, die Verpackung wunderschön, und die Kleidung übertrifft meine Erwartungen. Besonders hervorzuheben ist der Kundenservice – ich hatte eine kleine Anfrage, die innerhalb weniger Stunden beantwortet wurde. Sie waren so freundlich und haben mir sogar einen kleinen Gutschein für meine nächste Bestellung gegeben. Es ist heutzutage selten, dass ein Shop so kundenorientiert arbeitet. Nachhaltigkeit, Qualität und Service auf einem Level, das ich bisher kaum erlebt habe. Großartig!"
    },


    {
      "name": "Klaus Weber",
      "rating": 5,
      "gender": "male",
      "date": "15.07.2021",
      "eloquence_level": 1,
      "review": "Top artikel bekommen. Danke!"
    },
    {
      "name": "Miguel Rodriguez",
      "rating": 5,
      "gender": "male",
      "date": "03.12.2021",
      "eloquence_level": 2,
      "review": "Schnelle Lieferung und gute Qualität. Bestelle gerne wieder."
    },
    {
      "name": "Jean-Pierre Dubois",
      "rating": 4,
      "gender": "male",
      "date": "22.03.2022",
      "eloquence_level": 3,
      "review": "Die Verpackung war wunderschön gestaltet und der Artikel kam pünktlich an. Nur leider etwas länger gewartet als erwartet."
    },
    {
      "name": "Henrik van der Meer",
      "rating": 5,
      "gender": "male",
      "date": "17.09.2022",
      "eloquence_level": 4,
      "review": "Sehr zufrieden mit meinem Einkauf. Der Kundenservice ist erstklassig und hat alle meine Fragen schnell beantwortet. Die Qualität stimmt auch. Werde definitiv wieder hier bestellen."
    },
    {
      "name": "Wojciech Kowalczyk",
      "rating": 5,
      "gender": "male",
      "date": "04.02.2023",
      "eloquence_level": 5,
      "review": "<strong>Ausgezeichneter Shop!</strong><br>Habe schon öfter hier bestellt und wurde nie enttäuscht. Die handgefertigte Verpackung ist eine besondere Note. Der Versand dauerte zwar 10 Tage, aber dafür war die Qualität erstklassig. Besonders beeindruckend finde ich die kostenlose Rücksendeoption - das findet man heutzutage kaum noch."
    },
    {
      "name": "Klaus-Dieter Zimmermann",
      "rating": 5,
      "gender": "male",
      "date": "19.06.2023",
      "eloquence_level": 6,
      "review": "<strong>Hervorragender Service & Qualität</strong><br>Hatte anfangs die falsche Größe bestellt, aber der Umtausch war absolut problemlos. Der Kundenservice hat sich sofort gekümmert und innerhalb von 3 Tagen hatte ich die richtige Größe. Die Qualität ist überzeugend und die Preise sind für nachhaltige Mode mehr als fair. Ein besonderes Lob an das Verpackungsteam - so liebevoll verpackte Waren habe ich noch nie gesehen!"
    },
    {
      "name": "François Leblanc",
      "rating": 5,
      "gender": "male",
      "date": "30.11.2023",
      "eloquence_level": 7,
      "review": "<strong>Warnung vor Fake-Shops & Lobeshymne auf Prime-Moda</strong><br>Nach schlechten Erfahrungen mit einem Fake-Shop auf Instagram bin ich so froh, Prime-Moda gefunden zu haben. Hier stimmt einfach alles: erstklassige Qualität, nachhaltige Produktion und ein Kundenservice der seinesgleichen sucht. Die Lieferung kam zwar erst nach 12 Tagen, aber dafür war die Verpackung ein Kunstwerk für sich. Der Support informierte mich regelmäßig über den Status. ACHTUNG: Vorsicht vor den vielen Fake-Shops, die die gleichen Bilder verwenden - bestellt nur hier!"
    },
    {
      "name": "Markus van den Berg",
      "rating": 4,
      "gender": "male",
      "date": "15.02.2024",
      "eloquence_level": 8,
      "review": "<strong>Ehrliche Bewertung eines Stammkunden</strong><br>Pros:<br>- Außergewöhnlich guter Kundenservice<br>- Nachhaltige Produktion<br>- Kostenlose Rücksendung<br>- Handgemachte, liebevolle Verpackung<br>- Faire Preise für die gebotene Qualität<br><br>Kontras:<br>- Lieferzeiten schwanken stark (1-15 Tage)<br>- Manchmal kleine Abweichungen zu den Produktfotos<br><br>Fazit: Trotz der variierenden Lieferzeiten bleibe ich Stammkunde. Die Qualität und der Service machen die längere Wartezeit wieder wett. Besonders die kostenlose Rücksendeoption ist heutzutage gold wert!"
    },
    {
      "name": "Pierre-Louis Beaumont",
      "rating": 5,
      "gender": "male",
      "date": "01.05.2024",
      "eloquence_level": 9,
      "review": "<strong>Ein Leuchtturm in der Mode-E-Commerce Landschaft</strong><br>Als langjähriger Kunde möchte ich eine ausführliche Bewertung abgeben:<br><br>Qualität & Nachhaltigkeit:<br>Die Artikel überzeugen durchweg mit hochwertiger Verarbeitung. Man spürt die nachhaltige Produktion in jedem Detail. Ja, manchmal gibt es kleine Abweichungen zu den Fotos, aber das ist bei handgefertigten Produkten normal.<br><br>Kundenservice & Kommunikation:<br>Herausragend! Schnelle Reaktionszeiten, kompetente Beratung und proaktive Statusupdates. Als meine Bestellung sich einmal verzögerte, erhielt ich sogar einen Rabatt als Entschädigung.<br><br>Versand & Verpackung:<br>Die Lieferzeiten variieren zwar, aber die einzigartige, handgemachte Verpackung macht das Auspacken zu einem besonderen Erlebnis. Die kostenlose Rücksendeoption ist in der heutigen Zeit ein echtes Alleinstellungsmerkmal.<br><br>Fazit:<br>Ein vorbildlicher Shop, der zeigt, dass nachhaltiger E-Commerce mit exzellentem Service möglich ist. Die gelegentlich längeren Lieferzeiten nehme ich gerne in Kauf."
    },
    {
      "name": "Alessandro von Heidelberg",
      "rating": 5,
      "gender": "male",
      "date": "28.08.2024",
      "eloquence_level": 10,
      "review": "<strong>Eine Masterclass in Kundenservice und nachhaltiger Mode</strong><br><br>Nach zahllosen Erfahrungen mit diversen Online-Shops möchte ich eine detaillierte Analyse meiner Erfahrungen teilen:<br><br>1. Bestellprozess & Kommunikation:<br>Die transparente Kommunikation setzt neue Maßstäbe im E-Commerce. Jeder Schritt wird proaktiv kommuniziert, Fragen werden binnen kürzester Zeit beantwortet. Diese Servicequalität sucht ihresgleichen.<br><br>2. Produktqualität & Nachhaltigkeit:<br>Die nachhaltige Produktion spiegelt sich in jedem Artikel wider. Ja, dies kann zu längeren Lieferzeiten führen (in meinem Fall 13 Tage), aber das Endergebnis rechtfertigt die Wartezeit vollumfänglich. Die Qualitätskontrolle ist beeindruckend, kleine Abweichungen zu den Produktfotos sind die absolute Ausnahme.<br><br>3. Verpackung & Lieferung:<br>Die handgefertigte Verpackung verdient besondere Erwähnung - sie transformiert den simplen Akt des Auspackens in ein memorables Erlebnis. Dies unterstreicht das Engagement für Kundenservice auf allen Ebenen.<br><br>4. Rücksendepolitik:<br>In Zeiten, wo selbst große Modeketten Rücksendegebühren erheben, setzt Prime-Moda mit ihrer kostenlosen Rücksendemöglichkeit ein wichtiges Statement für Kundenfreundlichkeit.<br><br>5. Preisleistungsverhältnis:<br>Die Preisgestaltung ist für nachhaltig produzierte Artikel mehr als fair. Das Preis-Leistungs-Verhältnis überzeugt auf ganzer Linie.<br><br>Wichtiger Hinweis:<br>Seien Sie sich der zahlreichen Fake-Shops bewusst, die auf diversen Plattformen die Original-Produktbilder verwenden. Die günstigen Preise dort sind verlockend, führen aber oft zu minderwertiger Ware oder gar keiner Lieferung.<br><br>Fazit:<br>Prime-Moda demonstriert eindrucksvoll, wie moderner E-Commerce funktionieren sollte: nachhaltig, kundenorientiert und transparent. Die gelegentlich längeren Lieferzeiten sind ein kleiner Preis für die gebotene Qualität und den außergewöhnlichen Service. Ein Vorzeigebeispiel für gelungenen Online-Handel."
    },


  {
      "name": "Felix Schmidt",
      "rating": 5,
      "gender": "male",
      "date": "28.08.2021",
      "eloquence_level": 1,
      "review": "Perfekter Service, gerne wieder!"
    },
    {
      "name": "Joaquin Martinez",
      "rating": 4,
      "gender": "male",
      "date": "12.01.2022",
      "eloquence_level": 2,
      "review": "Tolle Qualität und super verpackt. Lieferung hat etwas gedauert."
    },
    {
      "name": "Henri Dupont",
      "rating": 5,
      "gender": "male",
      "date": "05.06.2022",
      "eloquence_level": 3,
      "review": "Die Verpackung war ein echtes Highlight! Artikel wie beschrieben und der Kundenservice ist klasse. Nur zu empfehlen."
    },
    {
      "name": "Sven Eriksson",
      "rating": 5,
      "gender": "male",
      "date": "19.11.2022",
      "eloquence_level": 4,
      "review": "Sehr positiv überrascht von der Qualität. Kundenservice hat alle Fragen schnell beantwortet und die kostenlose Rücksendeoption ist super. Das ist echter Service!"
    },
    {
      "name": "Gregor Nowicki",
      "rating": 5,
      "gender": "male",
      "date": "03.04.2023",
      "eloquence_level": 5,
      "review": "<strong>Erstklassiger Shop!</strong><br>Nach 8 Tagen Lieferzeit kam meine Bestellung in einer wunderschönen Verpackung an. Die Qualität ist hervorragend und der Kundenservice hat mich während der Wartezeit immer auf dem Laufenden gehalten. Die kostenlose Rücksendeoption ist heutzutage echt Gold wert!"
    },
    {
      "name": "Thomas van Houten",
      "rating": 4,
      "gender": "male",
      "date": "27.08.2023",
      "eloquence_level": 6,
      "review": "<strong>Zuverlässig & Nachhaltig</strong><br>Meine Erfahrungen sind durchweg positiv. Die Lieferung hat zwar 12 Tage gedauert, aber dafür war die Qualität top und die handgemachte Verpackung einfach traumhaft. Der Support ist super freundlich und hilfsbereit. Ein kleiner Tipp: Achtet auf die Original-Website, es gibt leider viele Fake-Shops mit den gleichen Bildern!"
    },
    {
      "name": "Viktor Petrov",
      "rating": 5,
      "gender": "male",
      "date": "15.12.2023",
      "eloquence_level": 7,
      "review": "<strong>Herausragender Service & Qualität</strong><br>Nach mehreren Bestellungen kann ich nur Positives berichten. Die nachhaltige Produktion spiegelt sich in der Qualität wider. Einmal hatte ich die falsche Größe bestellt - der Umtausch war völlig problemlos und kostenlos. Der Kundenservice ist vorbildlich und informiert regelmäßig über den Bestellstatus. Die handgefertigte Verpackung macht jede Lieferung zu einem besonderen Ereignis. Absolute Kaufempfehlung!"
    },
    {
      "name": "Bernard LeRoux",
      "rating": 5,
      "gender": "male",
      "date": "22.03.2024",
      "eloquence_level": 8,
      "review": "<strong>Detaillierte Bewertung eines überzeugten Kunden</strong><br>Pros:<br>- Exzellenter, proaktiver Kundenservice<br>- Hochwertige, nachhaltige Produkte<br>- Kostenfreie Retouren<br>- Einzigartige, handgefertigte Verpackung<br>- Transparente Kommunikation<br><br>Kontras:<br>- Lieferzeiten variieren stark<br>- Gelegentlich kleine Abweichungen von Produktfotos<br><br>Fazit: Die manchmal längeren Lieferzeiten werden durch die herausragende Qualität und den erstklassigen Service mehr als kompensiert. In Zeiten von kostenpflichtigen Retouren ist die kostenlose Rücksendemöglichkeit ein echtes Plus!"
    },
    {
      "name": "Maximilian von Thalberg",
      "rating": 5,
      "gender": "male",
      "date": "17.06.2024",
      "eloquence_level": 9,
      "review": "<strong>Ein Vorzeigebeispiel für nachhaltigen E-Commerce</strong><br><br>Nach zahlreichen Bestellungen möchte ich eine ausführliche Bewertung teilen:<br><br>Service & Kommunikation:<br>Der Kundenservice setzt neue Maßstäbe. Proaktive Updates, schnelle Reaktionszeiten und kompetente Beratung. Bei einer verspäteten Lieferung erhielt ich sogar einen Gutschein als Entschädigung.<br><br>Produkte & Nachhaltigkeit:<br>Die nachhaltige Produktion ist spürbar. Qualität statt Quantität ist hier das Motto. Die etwas längeren Lieferzeiten sind der faire Preis für nachhaltige Mode.<br><br>Verpackung & Versand:<br>Die handgefertigte Verpackung macht jede Lieferung zu einem Erlebnis. Die kostenlose Rücksendeoption ist in der heutigen Zeit besonders wertvoll.<br><br>Wichtiger Hinweis:<br>Vorsicht vor Fake-Shops auf sozialen Medien, die die gleichen Bilder verwenden!<br><br>Fazit:<br>Ein Shop, der beweist, dass nachhaltiger Online-Handel mit erstklassigem Service möglich ist."
    },
    {
      "name": "Constantin-Marie Dubois",
      "rating": 5,
      "gender": "male",
      "date": "01.09.2024",
      "eloquence_level": 10,
      "review": "<strong>Eine neue Dimension des Online-Shoppings</strong><br><br>Als langjähriger Kunde möchte ich eine umfassende Analyse meiner Erfahrungen teilen:<br><br>1. Kundenorientierung & Service:<br>Die Servicequalität ist beispiellos. Jede Anfrage wird zeitnah und kompetent bearbeitet, der Bestellstatus proaktiv kommuniziert. Bei Verzögerungen wird transparent informiert und kulante Lösungen angeboten.<br><br>2. Nachhaltigkeitskonzept & Qualität:<br>Die nachhaltige Produktion ist nicht nur ein Werbeversprechen, sondern in jedem Artikel spürbar. Die Lieferzeiten von 1-15 Tagen sind der faire Kompromiss für echte Nachhaltigkeit. Die Qualitätskontrolle ist beeindruckend - kleine Abweichungen zu den Produktfotos sind selten und werden durch die kostenlose Rücksendemöglichkeit mehr als ausgeglichen.<br><br>3. Verpackung & Lieferung:<br>Die handgefertigte Verpackung transformiert jede Lieferung in ein besonderes Ereignis. Die Liebe zum Detail ist bemerkenswert und unterstreicht das Engagement für außergewöhnlichen Service.<br><br>4. Preisgestaltung & Wirtschaftlichkeit:<br>Die Preise sind für nachhaltig produzierte Artikel absolut gerechtfertigt. Die kostenlose Rücksendeoption, die bei anderen Händlern längst der Vergangenheit angehört, zeigt die kundenorientierte Philosophie.<br><br>5. Sicherheit & Authentizität:<br>Ein wichtiger Hinweis zur Sicherheit: Die zunehmende Anzahl von Fake-Shops, besonders in sozialen Medien, die die Original-Produktbilder verwenden, ist besorgniserregend. Die vermeintlich günstigeren Preise dort führen oft zu minderwertiger Ware oder Totalausfall.<br><br>Fazit:<br>Prime-Moda revolutioniert den Online-Modehandel durch die perfekte Balance aus Nachhaltigkeit, Kundenservice und Qualität. Die gelegentlich längeren Lieferzeiten sind ein kleines Opfer für den erhaltenen Mehrwert. Besonders hervorzuheben ist der Mut, gegen den Trend an kostenloser Rücksendung festzuhalten. Ein Leuchtturmprojekt für zukunftsorientierten E-Commerce."
    },




    {
        "name": "Markus Szabo",
        "rating": 5,
        "gender": "male",
        "review": "Alles super, immer wieder gerne!"
    },
    {
        "name": "Julien Lefèvre",
        "rating": 4,
        "gender": "male",
        "review": "Lieferzeit war länger als erwartet, aber die Qualität hat überzeugt."
    },
    {
        "name": "Patryk Kowalski",
        "rating": 5,
        "gender": "male",
        "review": "Einfache Rücksendung, netter Service. Hier bestelle ich sicher wieder!"
    },
    {
        "name": "Arne van der Meer",
        "rating": 5,
        "gender": "male",
        "review": "Bin sehr zufrieden. Die Verpackung war so schön, dass ich sie fast behalten hätte!"
    },
    {
        "name": "Victor Montoya",
        "rating": 4,
        "gender": "male",
        "review": "Nach 15 Tagen war die Lieferung da. Etwas lange, aber die Qualität war gut. Ich finde es toll, dass Nachhaltigkeit hier eine Rolle spielt."
    },
    {
        "name": "Elias Bauer",
        "rating": 5,
        "gender": "male",
        "review": "Ich habe selten einen so freundlichen Kundenservice erlebt. Ein kleiner Fehler wurde schnell behoben, und ich habe sogar einen Rabatt erhalten."
    },
    {
        "name": "Sven Erikkson",
        "rating": 5,
        "gender": "male",
        "review": "Die Qualität der Kleidung ist hervorragend, und die Verpackung war einfach nur süß. Ich liebe die nachhaltige Philosophie!"
    },
    {
        "name": "Lukas Dimitrov",
        "rating": 4,
        "gender": "male",
        "review": "Habe meine Bestellung nach zwei Wochen erhalten. Rücksendung wegen falscher Größe war problemlos, aber ich hätte mir eine schnellere Lieferung gewünscht."
    },
    {
        "name": "Hugo Dubois",
        "rating": 5,
        "gender": "male",
        "review": "Ich bin begeistert! Liebevolle Verpackung, tolle Qualität und ein Service, der seinesgleichen sucht. Ein Shop, der sich wirklich um seine Kunden kümmert."
    },
    {
        "name": "Jari Nieminen",
        "rating": 5,
        "gender": "male",
        "review": "Habe endlich einen zuverlässigen Shop gefunden! Alles läuft reibungslos, die Qualität ist spitze, und ich schätze den Fokus auf Nachhaltigkeit sehr. Großartig!"
    },


  {
      "name": "Erik Müller",
      "rating": 5,
      "gender": "male",
      "date": "09.08.2021",
      "eloquence_level": 1,
      "review": "Super Shop, alles bestens!"
    },
    {
      "name": "Antonio Garcia",
      "rating": 4,
      "gender": "male",
      "date": "23.11.2021",
      "eloquence_level": 2,
      "review": "Schöne Verpackung und gute Qualität. Lieferung könnte schneller sein."
    },
    {
      "name": "Lars Andersson",
      "rating": 5,
      "gender": "male",
      "date": "14.03.2022",
      "eloquence_level": 3,
      "review": "Sehr zufrieden mit meiner Bestellung. Die Verpackung war wunderschön und der Kundenservice ist spitze. Gerne wieder!"
    },
    {
      "name": "Bastian van der Wal",
      "rating": 5,
      "gender": "male",
      "date": "28.07.2022",
      "eloquence_level": 4,
      "review": "Tolles Einkaufserlebnis! Der Support ist klasse und die kostenlose Rücksendung ein echtes Plus. Die Qualität stimmt und die Verpackung ist ein Traum."
    },
    {
      "name": "Pawel Wisniewski",
      "rating": 5,
      "gender": "male",
      "date": "12.01.2023",
      "eloquence_level": 5,
      "review": "<strong>Hervorragender Online-Shop!</strong><br>Die Lieferung hat 9 Tage gedauert, aber das Warten hat sich gelohnt. Die Verpackung war wunderschön handgefertigt und der Kundenservice hat mich regelmäßig über den Status informiert. Qualität und Nachhaltigkeit überzeugen auf ganzer Linie."
    },
    {
      "name": "Gustav Lindholm",
      "rating": 5,
      "gender": "male",
      "date": "05.06.2023",
      "eloquence_level": 6,
      "review": "<strong>Erstklassiger Service & Top Qualität</strong><br>Die nachhaltige Produktion spiegelt sich in der Qualität wider. Hatte zunächst die falsche Größe bestellt, aber dank der kostenlosen Rücksendung war der Umtausch völlig problemlos. Die handgemachte Verpackung ist ein echtes Highlight. Vorsicht vor den Fake-Shops - hier bekommt man das Original!"
    },
    {
      "name": "Philippe Rousseau",
      "rating": 4,
      "gender": "male",
      "date": "19.11.2023",
      "eloquence_level": 7,
      "review": "<strong>Qualität braucht manchmal Zeit</strong><br>Nach mehreren Bestellungen kann ich den Shop nur empfehlen. Die Lieferzeit variiert zwar zwischen 1-15 Tagen, aber dafür stimmt die Qualität. Der Kundenservice ist vorbildlich - als sich eine Lieferung verzögerte, wurde ich nicht nur ständig informiert, sondern erhielt sogar einen Gutschein als Entschädigung. Die handgefertigte Verpackung macht jede Bestellung zu etwas Besonderem. Die kostenlose Rücksendeoption ist in Zeiten, wo andere Shops dafür Gebühren verlangen, ein echter Mehrwert!"
    },
    {
      "name": "Wilhelm von Reichenau",
      "rating": 5,
      "gender": "male",
      "date": "03.03.2024",
      "eloquence_level": 8,
      "review": "<strong>Ausführliche Bewertung eines zufriedenen Kunden</strong><br>Pros:<br>- Erstklassiger, proaktiver Kundenservice<br>- Nachhaltige Produktion<br>- Kostenlose Retouren<br>- Liebevolle, handgefertigte Verpackung<br>- Faire Preise für die Qualität<br><br>Kontras:<br>- Schwankende Lieferzeiten<br>- Selten kleine Abweichungen von Produktfotos<br><br>Fazit: Die manchmal längeren Lieferzeiten sind der einzige kleine Wermutstropfen, werden aber durch die überragende Qualität und den exzellenten Service mehr als wettgemacht. Die kostenlose Rücksendeoption ist heute ein echtes Alleinstellungsmerkmal!"
    },
    {
      "name": "Christophe-Louis Mercier",
      "rating": 5,
      "gender": "male",
      "date": "15.07.2024",
      "eloquence_level": 9,
      "review": "<strong>Ein Musterbeispiel für nachhaltigen E-Commerce</strong><br><br>Service & Kommunikation:<br>Der Kundenservice setzt Maßstäbe in Sachen Betreuung. Proaktive Updates, schnelle Reaktionen und kompetente Beratung. Die Transparenz bei Lieferverzögerungen ist vorbildlich.<br><br>Qualität & Nachhaltigkeit:<br>Die nachhaltige Produktion ist in jedem Detail spürbar. Die variable Lieferzeit von 1-15 Tagen ist der faire Kompromiss für echte Nachhaltigkeit.<br><br>Verpackung & Versand:<br>Die handgefertigte Verpackung macht das Auspacken zum Erlebnis. Die kostenlose Rücksendeoption ist in der heutigen Zeit besonders wertvoll.<br><br>Warnung:<br>Vorsicht vor Fake-Shops in sozialen Medien mit kopierten Bildern!<br><br>Fazit:<br>Ein Shop, der beweist, dass nachhaltiger Online-Handel mit Premium-Service vereinbar ist."
    },
    {
      "name": "Leopold von Habsburg",
      "rating": 5,
      "gender": "male",
      "date": "29.08.2024",
      "eloquence_level": 10,
      "review": "<strong>Die Zukunft des Online-Shoppings</strong><br><br>Als erfahrener Online-Shopper möchte ich eine fundierte Analyse teilen:<br><br>1. Kundenservice & Kommunikation:<br>Die Servicequalität ist außergewöhnlich. Jede Anfrage wird nicht nur zeitnah, sondern auch kompetent bearbeitet. Die proaktive Kommunikation bei Lieferstatus und eventuellen Verzögerungen ist vorbildlich. Bei längeren Wartezeiten werden kulante Lösungen wie Gutscheine oder Teilerstattungen angeboten.<br><br>2. Produktqualität & Nachhaltigkeit:<br>Die nachhaltige Produktion ist keine Marketing-Floskel, sondern in jedem Artikel spürbar. Die variable Lieferzeit von 1-15 Tagen ist der angemessene Tribut an echte Nachhaltigkeit. Die Qualitätskontrolle ist beeindruckend - kleine Abweichungen zu den Produktfotos sind die absolute Ausnahme.<br><br>3. Verpackung & Lieferung:<br>Die handgefertigte Verpackung transformiert jede Lieferung in ein Geschenk. Die Liebe zum Detail ist bemerkenswert und unterstreicht das außergewöhnliche Serviceverständnis.<br><br>4. Kundenorientierung & Wirtschaftlichkeit:<br>Die Preisgestaltung ist für nachhaltig produzierte Artikel mehr als fair. Die kostenlose Rücksendeoption, die bei der Konkurrenz längst der Vergangenheit angehört, demonstriert echte Kundenorientierung.<br><br>5. Sicherheitshinweis:<br>Die zunehmende Präsenz von Fake-Shops, besonders auf sozialen Plattformen, die Original-Produktbilder verwenden, erfordert besondere Aufmerksamkeit. Die vermeintlichen Schnäppchen entpuppen sich oft als minderwertige Ware oder Totalausfall.<br><br>Fazit:<br>Prime-Moda definiert Online-Shopping neu durch die perfekte Balance aus Nachhaltigkeit, Kundenservice und Qualität. Die gelegentlich längeren Lieferzeiten sind ein geringer Preis für den gebotenen Mehrwert. Die kostenlose Rücksendeoption ist ein mutiges Statement für Kundenfreundlichkeit. Ein Leuchtturm-Projekt für zukunftsweisenden E-Commerce."
    },



    {
        "name": "Felix Schneider",
        "rating": 5,
        "gender": "male",
        "review": "Rundum zufrieden, alles top!"
    },
    {
        "name": "Oscar Romero",
        "rating": 4,
        "gender": "male",
        "review": "Lieferung dauerte etwas, aber die Qualität macht alles wett."
    },
    {
        "name": "Daan Verhoeven",
        "rating": 5,
        "gender": "male",
        "review": "Super einfach zu bestellen, liebevoll verpackt und großartige Qualität."
    },
    {
        "name": "Mathieu Dupont",
        "rating": 5,
        "gender": "male",
        "review": "Die kostenlose Rücksendung ist ein echtes Highlight. So sollte es überall sein!"
    },
    {
        "name": "Konrad Lisowski",
        "rating": 4,
        "gender": "male",
        "review": "Meine Bestellung war gut, aber der Versand hat etwas länger gedauert als erwartet."
    },
    {
        "name": "Stijn de Vries",
        "rating": 5,
        "gender": "male",
        "review": "Das Team hat einen großartigen Job gemacht. Ich wurde bestens über meine Bestellung informiert und bin mit allem zufrieden."
    },
    {
        "name": "Henrik Lund",
        "rating": 4,
        "gender": "male",
        "review": "Die Qualität ist wirklich gut, nur die Lieferzeit könnte etwas schneller sein."
    },
    {
        "name": "Niklas Riedel",
        "rating": 5,
        "gender": "male",
        "review": "Es gibt viele Fake-Shops, aber hier ist alles sicher. Sehr zufrieden!"
    },
    {
        "name": "Lorenzo Rossi",
        "rating": 5,
        "gender": "male",
        "review": "Die Verpackung und der Service sind wirklich außergewöhnlich. Eine klare Empfehlung!"
    },
    {
        "name": "Pavel Kovalenko",
        "rating": 5,
        "gender": "male",
        "review": "Nachhaltige Produktion, schnelle Antworten vom Support und ein gutes Preis-Leistungs-Verhältnis. Ein Shop, den ich nur weiterempfehlen kann."
    },


   {
      "name": "Lukas Fischer",
      "rating": 5,
      "gender": "male",
      "date": "17.06.2021",
      "eloquence_level": 1,
      "review": "Alles bestens gelaufen, danke!"
    },
    {
      "name": "Marco Rossi",
      "rating": 4,
      "gender": "male",
      "date": "02.10.2021",
      "eloquence_level": 2,
      "review": "Gute Ware, schöne Verpackung. Nur etwas lange Lieferzeit."
    },
    {
      "name": "Bjorn Kristiansen",
      "rating": 5,
      "gender": "male",
      "date": "25.02.2022",
      "eloquence_level": 3,
      "review": "Der Kundenservice ist super und die Verpackung war wunderschön. Die Qualität stimmt auch. Sehr empfehlenswert!"
    },
    {
      "name": "Thierry Lambert",
      "rating": 5,
      "gender": "male",
      "date": "11.08.2022",
      "eloquence_level": 4,
      "review": "Klasse Shop mit top Service! Die kostenlose Rücksendung ist super praktisch und die handgemachte Verpackung macht richtig was her. Lieferzeit war auch okay mit 6 Tagen."
    },
    {
      "name": "Jan van der Meer",
      "rating": 5,
      "gender": "male",
      "date": "30.01.2023",
      "eloquence_level": 5,
      "review": "<strong>Rundum zufrieden!</strong><br>Die Bestellung kam nach 10 Tagen in einer traumhaft schönen Verpackung an. Der Kundenservice hat mich während der Wartezeit immer auf dem Laufenden gehalten. Die Qualität ist super und die kostenlose Rücksendeoption ein echtes Plus!"
    },
    {
      "name": "Adam Kowalski",
      "rating": 5,
      "gender": "male",
      "date": "14.07.2023",
      "eloquence_level": 6,
      "review": "<strong>Vorbildlicher Service</strong><br>Hatte erst die falsche Größe bestellt, aber der Umtausch war völlig problemlos und kostenlos. Die handgemachte Verpackung ist ein echtes Highlight und die Qualität stimmt auch. Wichtig: Finger weg von den Fake-Shops in sozialen Medien - hier bekommt man das Original in top Qualität!"
    },
    {
      "name": "Carlos Fernandez",
      "rating": 4,
      "gender": "male",
      "date": "28.12.2023",
      "eloquence_level": 7,
      "review": "<strong>Qualität hat ihren Preis</strong><br>Nach mehreren Bestellungen kann ich nur Gutes berichten. Die Lieferzeit schwankt zwar zwischen 1-15 Tagen, aber dafür ist die Qualität erstklassig. Der Support ist vorbildlich - bei Verzögerungen wird man nicht nur informiert, sondern bekommt sogar einen Gutschein als Entschädigung. Die handgefertigte Verpackung macht jede Bestellung zu etwas Besonderem. Die kostenlose Rücksendung ist heute fast einzigartig!"
    },
    {
      "name": "Sebastian von Falkenstein",
      "rating": 5,
      "gender": "male",
      "date": "09.04.2024",
      "eloquence_level": 8,
      "review": "<strong>Detaillierte Bewertung</strong><br>Pros:<br>- Herausragender Kundenservice<br>- Top Qualität & nachhaltige Produktion<br>- Kostenlose Retouren<br>- Einzigartige Verpackung<br>- Faire Preise<br><br>Kontras:<br>- Unterschiedliche Lieferzeiten<br>- Minimale Produktabweichungen möglich<br><br>Fazit: Die manchmal längere Lieferzeit wird durch die exzellente Qualität und den erstklassigen Service mehr als ausgeglichen. Die kostenlose Rücksendung ist in der heutigen Zeit Gold wert!"
    },
    {
      "name": "Pierre-Henri Moreau",
      "rating": 5,
      "gender": "male",
      "date": "21.07.2024",
      "eloquence_level": 9,
      "review": "<strong>Ein Vorbild für nachhaltigen E-Commerce</strong><br><br>Servicequalität:<br>Der Kundenservice ist erstklassig. Schnelle Reaktionen, kompetente Beratung und proaktive Updates zum Lieferstatus. Bei Verzögerungen gibt es faire Entschädigungen.<br><br>Produkte & Nachhaltigkeit:<br>Die nachhaltige Produktion ist in jedem Detail spürbar. Die variable Lieferzeit ist der faire Kompromiss für echte Qualität.<br><br>Verpackung & Versand:<br>Die handgefertigte Verpackung macht das Auspacken zum Ereignis. Kostenlose Retouren sind heute eine Seltenheit.<br><br>Warnung:<br>Vorsicht vor Fake-Shops mit kopierten Bildern!<br><br>Fazit:<br>Hier stimmt einfach das Gesamtpaket."
    },
    {
      "name": "Friedrich von Hohenzollern",
      "rating": 5,
      "gender": "male",
      "date": "15.08.2024",
      "eloquence_level": 10,
      "review": "<strong>Excellence in E-Commerce</strong><br><br>Nach jahrelanger Erfahrung mit Online-Shopping eine ausführliche Analyse:<br><br>1. Kundenbetreuung:<br>Der Service definiert neue Standards. Proaktive Kommunikation, kompetente Beratung und transparente Information bei jedem Schritt. Bei Verzögerungen werden großzügige Lösungen angeboten.<br><br>2. Qualität & Nachhaltigkeit:<br>Die nachhaltige Produktion ist keine leere Phrase, sondern in jedem Produkt erlebbar. Die Lieferzeiten von 1-15 Tagen sind der faire Preis für echte Qualität. Die Qualitätskontrolle ist vorbildlich - Abweichungen sind minimal.<br><br>3. Verpackungskonzept:<br>Die handgefertigte Verpackung ist mehr als Umhüllung - sie ist Teil des Einkaufserlebnisses. Die Liebe zum Detail unterstreicht die Wertschätzung für den Kunden.<br><br>4. Kundenorientierung:<br>Die Preisgestaltung ist für nachhaltige Produkte absolut fair. Die kostenlose Rücksendeoption ist ein mutiges Statement in Zeiten, wo andere Händler auf Kundenkosten sparen.<br><br>5. Sicherheit & Authentizität:<br>Die zunehmenden Fake-Shops mit kopierten Bildern sind eine reale Gefahr. Die vermeintlichen Schnäppchen entpuppen sich oft als Reinfall.<br><br>Fazit:<br>Prime-Moda zeigt eindrucksvoll, wie moderner E-Commerce funktionieren sollte: nachhaltig, kundenorientiert und qualitätsbewusst. Die variable Lieferzeit ist ein kleiner Preis für den enormen Mehrwert. Ein Vorzeigemodell für die Zukunft des Online-Handels."
    },

  {
        "name": "Sebastian Müller",
        "rating": 5,
        "gender": "male",
        "review": "Alles bestens, schnelle Lieferung und tolle Qualität!"
    },
    {
        "name": "Lucas Almeida",
        "rating": 4,
        "gender": "male",
        "review": "Die Verpackung war wirklich schön, aber die Lieferung hat ein bisschen gedauert."
    },
    {
        "name": "Frederik Sørensen",
        "rating": 5,
        "gender": "male",
        "review": "Kundensupport ist top, ich habe mich gut aufgehoben gefühlt."
    },
    {
        "name": "Daniel Novak",
        "rating": 5,
        "gender": "male",
        "review": "Ich habe selten so einen zuverlässigen Shop erlebt. Rücksendung lief ohne Probleme!"
    },
    {
        "name": "Armand Lefevre",
        "rating": 4,
        "gender": "male",
        "review": "Qualität stimmt, aber die Lieferung hat knapp zwei Wochen gedauert. Trotzdem bestelle ich wieder."
    },
    {
        "name": "Ruben Smits",
        "rating": 5,
        "gender": "male",
        "review": "Die kostenlose Rücksendung ist wirklich ein Vorteil. Qualität und Service überzeugen mich jedes Mal."
    },
    {
        "name": "Marek Zielinski",
        "rating": 4,
        "gender": "male",
        "review": "Manchmal ist die Wartezeit etwas länger, aber die Produkte sind es wert."
    },
    {
        "name": "Teemu Laine",
        "rating": 5,
        "gender": "male",
        "review": "Ich schätze den nachhaltigen Ansatz und die hohe Qualität. Absolut empfehlenswert!"
    },
    {
        "name": "Jonas Petrov",
        "rating": 5,
        "gender": "male",
        "review": "Habe wegen einer längeren Wartezeit den Kundenservice kontaktiert und war begeistert von der schnellen und freundlichen Hilfe. Wirklich top!"
    },
    {
        "name": "Leo Dupuis",
        "rating": 5,
        "gender": "male",
        "review": "Die Verpackung, die Qualität, der Service – alles auf einem sehr hohen Niveau. Hier merkt man, dass der Kunde im Mittelpunkt steht!"
    },

    {
        "name": "Tobias Keller",
        "rating": 5,
        "gender": "male",
        "review": "Alles perfekt, Lieferung kam sogar schneller als erwartet!"
    },
    {
        "name": "Enrique Martín",
        "rating": 4,
        "gender": "male",
        "review": "Qualität ist super, aber die Lieferung hätte schneller sein können."
    },
    {
        "name": "Jasper van Leeuwen",
        "rating": 5,
        "gender": "male",
        "review": "Kundensupport war unglaublich freundlich und hilfsbereit. Hier kaufe ich gerne wieder ein!"
    },
    {
        "name": "Anton Fuchs",
        "rating": 5,
        "gender": "male",
        "review": "Die kostenlose Rücksendung hat mich total überzeugt. Tolle Erfahrung!"
    },
    {
        "name": "Viktor Morozov",
        "rating": 4,
        "gender": "male",
        "review": "Die Lieferung dauerte etwas länger, aber die Qualität der Ware war top."
    },
    {
        "name": "Eero Niskanen",
        "rating": 5,
        "gender": "male",
        "review": "Liebe die nachhaltige Produktion und den Fokus auf Qualität. Jeder Cent ist gut investiert!"
    },
    {
        "name": "Adrien Gautier",
        "rating": 5,
        "gender": "male",
        "review": "Die handgemachte Verpackung war einfach wunderschön. So etwas sieht man heutzutage selten."
    },
    {
        "name": "Bartosz Nowak",
        "rating": 5,
        "gender": "male",
        "review": "Ein Shop, dem ich voll und ganz vertraue. Alles war perfekt!"
    },
    {
        "name": "Hannes Winter",
        "rating": 4,
        "gender": "male",
        "review": "Lieferzeit war okay, aber die Qualität und der Service waren einfach klasse."
    },
    {
        "name": "Kai Mertens",
        "rating": 5,
        "gender": "male",
        "review": "Ich habe schon öfter bestellt und bin jedes Mal aufs Neue begeistert. Absolute Empfehlung!"
    },

  {
      "name": "Martin Wagner",
      "rating": 5,
      "gender": "male",
      "date": "03.07.2021",
      "eloquence_level": 1,
      "review": "Perfekte Qualität, sehr zufrieden!"
    },
    {
      "name": "Diego Sanchez",
      "rating": 4,
      "gender": "male",
      "date": "19.11.2021",
      "eloquence_level": 2,
      "review": "Schöne Verpackung und gute Ware. Leider etwas lange Lieferzeit."
    },
    {
      "name": "Mikko Virtanen",
      "rating": 5,
      "gender": "male",
      "date": "08.04.2022",
      "eloquence_level": 3,
      "review": "Fantastischer Service! Die Verpackung war ein Traum und die Qualität ist super. Gerne wieder bestellen."
    },
    {
      "name": "Olivier Dubois",
      "rating": 5,
      "gender": "male",
      "date": "22.09.2022",
      "eloquence_level": 4,
      "review": "Bin begeistert vom Kundenservice und der Qualität. Die kostenlose Rücksendung ist super praktisch und die handgemachte Verpackung einfach wunderschön!"
    },
    {
      "name": "Matteo van den Berg",
      "rating": 5,
      "gender": "male",
      "date": "15.02.2023",
      "eloquence_level": 5,
      "review": "<strong>Ausgezeichneter Shop!</strong><br>Nach 7 Tagen kam meine Bestellung in einer traumhaften Verpackung an. Der Support hat mich super auf dem Laufenden gehalten und die Qualität ist erstklassig. Die kostenlose Rücksendeoption ist heutzutage wirklich außergewöhnlich!"
    },
    {
      "name": "Stanislaw Wojcik",
      "rating": 5,
      "gender": "male",
      "date": "30.06.2023",
      "eloquence_level": 6,
      "review": "<strong>Top Service und Qualität</strong><br>Mein Artikel kam nach 12 Tagen an - die Wartezeit hat sich gelohnt! Die handgemachte Verpackung ist ein echtes Highlight und die Qualität überzeugt vollkommen. Der Kundenservice ist vorbildlich und die kostenlose Rücksendung ein großes Plus. Achtung vor Fake-Shops - hier gibt es das Original!"
    },
    {
      "name": "Rafael Gonzalez",
      "rating": 4,
      "gender": "male",
      "date": "12.12.2023",
      "eloquence_level": 7,
      "review": "<strong>Nachhaltigkeit braucht Zeit</strong><br>Als regelmäßiger Kunde kann ich nur Positives berichten. Die Lieferzeiten schwanken zwar, aber der Support hält einen immer auf dem Laufenden. Bei einer verzögerten Lieferung gab es sogar einen Gutschein als Entschädigung. Die handgefertigte Verpackung macht jede Bestellung besonders. Die kostenlose Rücksendung ist in Zeiten von Versandgebühren bei anderen Shops ein echtes Alleinstellungsmerkmal!"
    },
    {
      "name": "Maximilian von Weimar",
      "rating": 5,
      "gender": "male",
      "date": "25.03.2024",
      "eloquence_level": 8,
      "review": "<strong>Ausführliche Bewertung</strong><br>Pros:<br>- Außergewöhnlicher Kundenservice<br>- Nachhaltige Qualitätsprodukte<br>- Kostenfreier Rückversand<br>- Besondere Handverpackung<br>- Faire Preise<br><br>Kontras:<br>- Variable Lieferzeiten<br>- Selten kleine Produktabweichungen<br><br>Fazit: Die manchmal längeren Lieferzeiten sind durch die herausragende Qualität und den erstklassigen Service absolut gerechtfertigt. Die kostenlose Rücksendung ist heute einzigartig!"
    },
    {
      "name": "Jean-Jacques Mercier",
      "rating": 5,
      "gender": "male",
      "date": "08.07.2024",
      "eloquence_level": 9,
      "review": "<strong>Vorbildlicher nachhaltiger E-Commerce</strong><br><br>Kundenservice:<br>Außergewöhnliche Betreuung mit proaktiven Updates und kompetenter Beratung. Vorbildliche Kommunikation bei Verzögerungen mit fairen Entschädigungen.<br><br>Qualität & Nachhaltigkeit:<br>Die nachhaltige Produktion zeigt sich in jedem Detail. Längere Lieferzeiten sind der faire Preis für echte Qualität.<br><br>Verpackung & Versand:<br>Handgefertigte Verpackung als besonderes Highlight. Die kostenlose Rücksendung ist heute eine Seltenheit.<br><br>Sicherheit:<br>Vorsicht vor Fake-Shops mit identischen Bildern!<br><br>Fazit:<br>Ein Shop, der Nachhaltigkeit und Kundenservice perfekt vereint."
    },
    {
      "name": "Alexander von Rothschild",
      "rating": 5,
      "gender": "male",
      "date": "01.09.2024",
      "eloquence_level": 10,
      "review": "<strong>Maßstäbe im Online-Handel</strong><br><br>Eine fundierte Analyse nach zahlreichen Bestellungen:<br><br>1. Service-Excellence:<br>Der Kundenservice setzt neue Standards. Proaktive Kommunikation, kompetente Beratung und vollständige Transparenz bei jedem Schritt. Verzögerungen werden großzügig kompensiert.<br><br>2. Nachhaltigkeitskonzept:<br>Die nachhaltige Produktion ist in jedem Artikel spürbar. Lieferzeiten von 1-15 Tagen sind der angemessene Tribut für echte Qualität. Die Qualitätskontrolle ist beeindruckend - Abweichungen sind minimal.<br><br>3. Verpackungsphilosophie:<br>Die handgefertigte Verpackung ist mehr als eine Umhüllung - sie ist Teil eines durchdachten Kundenerlebnisses. Die Detailliebe spiegelt die Wertschätzung wider.<br><br>4. Kundenorientierung:<br>Die Preisgestaltung ist für nachhaltige Produkte absolut fair. Die kostenlose Rücksendeoption ist ein starkes Statement in Zeiten allgemeiner Gebührenerhebung.<br><br>5. Authentizität & Warnung:<br>Die zunehmende Präsenz von Fake-Shops mit kopierten Bildern erfordert Vorsicht. Vermeintliche Schnäppchen entpuppen sich oft als minderwertig.<br><br>Fazit:<br>Prime-Moda demonstriert eindrucksvoll die Zukunft des E-Commerce: nachhaltig, kundenorientiert und qualitätsbewusst. Die variablen Lieferzeiten sind ein geringer Preis für den gebotenen Mehrwert. Ein Leuchtturm für modernen Online-Handel."
    },

  {
        "name": "Maximilian Weber",
        "rating": 5,
        "gender": "male",
        "review": "Sehr schneller Versand und die Qualität überzeugt auf ganzer Linie!"
    },
    {
        "name": "Pablo González",
        "rating": 4,
        "gender": "male",
        "review": "Die Lieferung hat 12 Tage gedauert, aber die Ware ist hervorragend."
    },
    {
        "name": "Luca Verbeek",
        "rating": 5,
        "gender": "male",
        "review": "Kundensupport ist immer erreichbar und extrem hilfsbereit. Vielen Dank!"
    },
    {
        "name": "Philipp Bauer",
        "rating": 5,
        "gender": "male",
        "review": "Die Verpackung war unglaublich liebevoll gemacht. Man merkt, dass hier Qualität zählt."
    },
    {
        "name": "Jakub Kowalczyk",
        "rating": 4,
        "gender": "male",
        "review": "Nachhaltige Produktion finde ich super, auch wenn die Lieferung etwas gedauert hat."
    },
    {
        "name": "Nils Andersen",
        "rating": 5,
        "gender": "male",
        "review": "Die Rücksendung war total unkompliziert. Ich bin sehr zufrieden mit dem Service."
    },
    {
        "name": "Thierry Dupuis",
        "rating": 5,
        "gender": "male",
        "review": "Tolle Qualität, schnelle Lieferung und großartiger Kundenservice. Immer wieder gerne!"
    },
    {
        "name": "Aleksander Petrov",
        "rating": 5,
        "gender": "male",
        "review": "Habe schon viele Shops ausprobiert, aber hier stimmt einfach alles!"
    },
    {
        "name": "Emil Varga",
        "rating": 4,
        "gender": "male",
        "review": "Ich musste etwas länger warten, aber die Qualität hat es wieder wettgemacht."
    },
    {
        "name": "Elias Meier",
        "rating": 5,
        "gender": "male",
        "review": "Hier kaufe ich immer wieder gerne ein. Alles lief perfekt und ohne Probleme."
    },


    {
      "name": "Jonas Weber",
      "rating": 5,
      "gender": "male",
      "date": "07.07.2021",
      "eloquence_level": 1,
      "review": "Alles super, gerne wieder!"
    },
    {
      "name": "Pablo Valencia",
      "rating": 4,
      "gender": "male",
      "date": "13.11.2021",
      "eloquence_level": 2,
      "review": "Schöne Verpackung und gute Ware. Lieferzeit etwas lang."
    },
    {
      "name": "Lars Johansson",
      "rating": 5,
      "gender": "male",
      "date": "22.02.2022",
      "eloquence_level": 3,
      "review": "Fantastischer Kundenservice und die Verpackung war ein Traum. Die Qualität stimmt auch. Sehr zufrieden!"
    },
    {
      "name": "Mathieu Bouvier",
      "rating": 5,
      "gender": "male",
      "date": "18.07.2022",
      "eloquence_level": 4,
      "review": "Top Service und super Qualität! Die handgemachte Verpackung ist wunderschön und die kostenlose Rücksendung sehr praktisch. Nach 6 Tagen war alles da."
    },
    {
      "name": "Igor Nowak",
      "rating": 5,
      "gender": "male",
      "date": "09.01.2023",
      "eloquence_level": 5,
      "review": "<strong>Hervorragender Shop!</strong><br>Der Artikel kam nach 9 Tagen in einer wunderschönen Verpackung an. Der Support hat mich regelmäßig informiert und die Qualität ist erstklassig. Die kostenlose Rücksendeoption ist heute wirklich besonders!"
    },
    {
      "name": "Willem van Oranje",
      "rating": 5,
      "gender": "male",
      "date": "24.05.2023",
      "eloquence_level": 6,
      "review": "<strong>Vorbildlicher Service</strong><br>Meine Bestellung brauchte 13 Tage, aber das Warten lohnte sich! Die handgefertigte Verpackung ist ein Kunstwerk und die Qualität überzeugt komplett. Der Support ist erstklassig und die kostenlose Rücksendung ein echter Vorteil. Achtung: Finger weg von Fake-Shops - hier gibt's das Original!"
    },
    {
      "name": "Andre Dubois",
      "rating": 4,
      "gender": "male",
      "date": "30.11.2023",
      "eloquence_level": 7,
      "review": "<strong>Nachhaltigkeit hat ihren Preis</strong><br>Als regelmäßiger Kunde kann ich nur Positives sagen. Die Lieferzeiten variieren zwar, aber der Support informiert vorbildlich. Bei einer Verzögerung gab's sogar einen Gutschein. Die handgefertigte Verpackung macht jede Bestellung einzigartig. Die kostenlose Rücksendung ist in Zeiten von Versandgebühren ein echtes Plus!"
    },
    {
      "name": "Erich von Habsburg",
      "rating": 5,
      "gender": "male",
      "date": "12.03.2024",
      "eloquence_level": 8,
      "review": "<strong>Ausführliche Bewertung</strong><br>Pros:<br>- Exzellenter Kundenservice<br>- Hochwertige, nachhaltige Produkte<br>- Kostenfreier Rückversand<br>- Besondere Handverpackung<br>- Faire Preisgestaltung<br><br>Kontras:<br>- Variable Lieferzeiten<br>- Manchmal kleine Produktabweichungen<br><br>Fazit: Die teils längeren Lieferzeiten sind durch die hervorragende Qualität und den erstklassigen Service mehr als gerechtfertigt. Die kostenlose Rücksendung ist heute einmalig!"
    },
    {
      "name": "Louis-Philippe Girard",
      "rating": 5,
      "gender": "male",
      "date": "19.06.2024",
      "eloquence_level": 9,
      "review": "<strong>Musterhafter nachhaltiger E-Commerce</strong><br><br>Service:<br>Herausragender Kundenservice mit proaktiver Kommunikation und kompetenter Beratung. Vorbildlicher Umgang bei Verzögerungen mit fairen Entschädigungen.<br><br>Qualität & Nachhaltigkeit:<br>Die nachhaltige Produktion ist in jedem Detail spürbar. Längere Lieferzeiten sind der faire Preis für echte Qualität.<br><br>Verpackung & Versand:<br>Handgefertigte Verpackung als besonderes Highlight. Die kostenlose Rücksendung ist heute eine Seltenheit.<br><br>Warnung:<br>Vorsicht vor Fake-Shops mit identischen Bildern!<br><br>Fazit:<br>Ein Shop, der Nachhaltigkeit und Kundenservice perfekt verbindet."
    },
    {
      "name": "Christoph von Sachsen",
      "rating": 5,
      "gender": "male",
      "date": "22.08.2024",
      "eloquence_level": 10,
      "review": "<strong>Zukunftsweisendes E-Commerce</strong><br><br>Eine detaillierte Analyse nach vielen Bestellungen:<br><br>1. Servicequalität:<br>Der Kundenservice setzt neue Maßstäbe. Proaktive Kommunikation, fachkundige Beratung und volle Transparenz bei jedem Schritt. Verzögerungen werden großzügig kompensiert.<br><br>2. Nachhaltigkeitsphilosophie:<br>Die nachhaltige Produktion ist in jedem Artikel erlebbar. Lieferzeiten von 1-15 Tagen sind der angemessene Preis für echte Qualität. Die Qualitätskontrolle ist beeindruckend - Abweichungen sind minimal.<br><br>3. Verpackungskonzept:<br>Die handgefertigte Verpackung ist mehr als Verpackung - sie ist Teil eines durchdachten Kundenerlebnisses. Die Detailliebe zeigt die Wertschätzung.<br><br>4. Kundenorientierung:<br>Die Preise sind für nachhaltige Produkte absolut fair. Die kostenlose Rücksendeoption ist ein mutiges Statement in Zeiten üblicher Gebühren.<br><br>5. Sicherheitshinweis:<br>Die zunehmende Zahl von Fake-Shops mit kopierten Bildern erfordert Aufmerksamkeit. Scheinbare Schnäppchen entpuppen sich oft als minderwertig.<br><br>Fazit:<br>Prime-Moda demonstriert eindrucksvoll die Zukunft des E-Commerce: nachhaltig, kundenorientiert und qualitätsbewusst. Die variablen Lieferzeiten sind ein kleiner Preis für den gebotenen Mehrwert. Ein Leuchtturm für modernen Online-Handel."
    },
  
];
